/**
 * GENERATED — do not edit. Run `npm run gen:api`.
 *
 * Runtime validation schemas, generated from the same /openapi.json that
 * produces schema.d.ts. Types vanish at compile time; these do not, so a
 * response whose shape the spec does not describe is detected rather than
 * believed.
 */
import { z } from "zod";

type WorkflowStep = {
  body?: Array<WorkflowStep> | undefined;
  config?: unknown;
  id: string;
  kind: StepKind;
  no?: Array<WorkflowStep> | undefined;
  yes?: Array<WorkflowStep> | undefined;
};
type StepKind =
  | "set_property"
  | "assign_owner"
  | "create_task"
  | "send_email"
  | "send_sms"
  | "notify"
  | "move_stage"
  | "webhook"
  | "wait"
  | "wait_until"
  | "branch"
  | "end"
  | "go_to"
  | "repeat";

export const owner_user_id = z.union([z.string(), z.null()]).optional();
export const page = z.union([z.number(), z.null()]).optional();
export const ActivityKind = z.enum(["note", "task", "call", "meeting"]);
export const ActivityObjectType = z.enum(["deal", "company", "submission", "person"]);
export const ActivityLink = z
  .object({
    label: z.union([z.string(), z.null()]).optional(),
    object_id: z.string(),
    object_type: ActivityObjectType,
  })
  .passthrough();
export const ActivityStatus = z.enum(["open", "done"]);
export const Activity = z
  .object({
    body: z.string(),
    can_complete: z.boolean(),
    can_edit: z.boolean(),
    completed_at: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    created_by: z.string(),
    created_by_name: z.union([z.string(), z.null()]).optional(),
    due_at: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    kind: ActivityKind,
    links: z.array(ActivityLink),
    outcome: z.union([z.string(), z.null()]).optional(),
    overdue: z.boolean(),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    reminder_at: z.union([z.string(), z.null()]).optional(),
    status: ActivityStatus,
    subject: z.string(),
    updated_at: z.string(),
  })
  .passthrough();
export const Pagination = z
  .object({
    page: z.number().int(),
    page_size: z.number().int(),
    total: z.number().int(),
    total_pages: z.number().int(),
  })
  .passthrough();
export const ActivityListResponse = z
  .object({ activities: z.array(Activity), pagination: Pagination })
  .passthrough();
export const ProblemDetails = z
  .object({
    detail: z.string(),
    error: z.string(),
    instance: z.union([z.string(), z.null()]).optional(),
    status: z.number().int().gte(0),
    success: z.boolean(),
    title: z.string(),
    type: z.string(),
  })
  .passthrough();
export const ActivityLinkInput = z
  .object({ object_id: z.string(), object_type: ActivityObjectType })
  .passthrough();
export const CreateActivityBody = z
  .object({
    body: z.union([z.string(), z.null()]).optional(),
    due_at: z.union([z.string(), z.null()]).optional(),
    kind: ActivityKind,
    links: z.union([z.array(ActivityLinkInput), z.null()]).optional(),
    outcome: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    reminder_at: z.union([z.string(), z.null()]).optional(),
    subject: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const UpdateActivityBody = z
  .object({
    body: z.union([z.string(), z.null()]),
    due_at: z.union([z.string(), z.null()]),
    links: z.union([z.array(ActivityLinkInput), z.null()]),
    outcome: z.union([z.string(), z.null()]),
    owner_user_id: z.union([z.string(), z.null()]),
    reminder_at: z.union([z.string(), z.null()]),
    subject: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const Alert = z
  .object({
    campaign_ids: z.array(z.string()),
    enabled: z.boolean(),
    event_type: z.string(),
    id: z.string(),
    last_fired_at: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    new_lead_scope: z.string(),
    notify_in_app: z.boolean(),
    notify_push: z.boolean(),
    threshold_count: z.union([z.number(), z.null()]).optional(),
    threshold_pct: z.union([z.number(), z.null()]).optional(),
    window_minutes: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const AlertListResponse = z.object({ alerts: z.array(Alert) }).passthrough();
export const CreateAlertBody = z
  .object({
    campaign_ids: z.array(z.string()).optional(),
    enabled: z.boolean().optional(),
    event_type: z.string(),
    name: z.string(),
    new_lead_scope: z.union([z.string(), z.null()]).optional(),
    notify_in_app: z.boolean().optional(),
    notify_push: z.boolean().optional(),
    threshold_count: z.union([z.number(), z.null()]).optional(),
    threshold_pct: z.union([z.number(), z.null()]).optional(),
    window_minutes: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const AlertWriteResponse = z.object({ id: z.string() }).passthrough();
export const UpdateAlertBody = z
  .object({
    campaign_ids: z.union([z.array(z.string()), z.null()]),
    enabled: z.union([z.boolean(), z.null()]),
    event_type: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    new_lead_scope: z.union([z.string(), z.null()]),
    notify_in_app: z.union([z.boolean(), z.null()]),
    notify_push: z.union([z.boolean(), z.null()]),
    threshold_count: z.union([z.number(), z.null()]),
    threshold_pct: z.union([z.number(), z.null()]),
    window_minutes: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const Caps = z
  .object({
    daily_cap: z.number().int(),
    daily_count: z.number().int(),
    monthly_cap: z.number().int(),
    monthly_count: z.number().int(),
    weekly_cap: z.number().int(),
    weekly_count: z.number().int(),
  })
  .passthrough();
export const ActiveHours = z
  .object({
    end: z.number().int().gte(0),
    start: z.number().int().gte(0),
    timezone: z.string().optional(),
  })
  .passthrough();
export const AssignmentRep = z
  .object({
    active: z.boolean(),
    active_days: z.array(z.number().int()),
    active_hours: z.union([z.null(), ActiveHours]).optional(),
    caps: Caps,
    destination_id: z.string(),
    link_id: z.string(),
    priority: z.number().int(),
    user_id: z.string(),
    user_name: z.string(),
    weight: z.number().int(),
  })
  .passthrough();
export const AssignmentGroup = z
  .object({
    active: z.boolean(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    caps: Caps,
    create_task: z.boolean(),
    distribution_method: z.string(),
    id: z.string(),
    name: z.string(),
    notify: z.boolean(),
    priority: z.number().int(),
    reps: z.array(AssignmentRep),
    task_due_minutes: z.number().int(),
    team_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const AssignmentGroupList = z
  .object({ groups: z.array(AssignmentGroup) })
  .passthrough();
export const AssignmentRepInput = z
  .object({
    active: z.union([z.boolean(), z.null()]).optional(),
    active_days: z.union([z.array(z.number().int()), z.null()]).optional(),
    active_hours: z.union([z.null(), ActiveHours]).optional(),
    daily_cap: z.union([z.number(), z.null()]).optional(),
    monthly_cap: z.union([z.number(), z.null()]).optional(),
    priority: z.union([z.number(), z.null()]).optional(),
    user_id: z.string(),
    weekly_cap: z.union([z.number(), z.null()]).optional(),
    weight: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const CreateAssignmentGroupBody = z
  .object({
    campaign_id: z.string(),
    create_task: z.union([z.boolean(), z.null()]).optional(),
    distribution_method: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    notify: z.union([z.boolean(), z.null()]).optional(),
    reps: z.union([z.array(AssignmentRepInput), z.null()]).optional(),
    task_due_minutes: z.union([z.number(), z.null()]).optional(),
    team_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const UpdateAssignmentGroupBody = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    create_task: z.union([z.boolean(), z.null()]),
    daily_cap: z.union([z.number(), z.null()]),
    distribution_method: z.union([z.string(), z.null()]),
    monthly_cap: z.union([z.number(), z.null()]),
    name: z.union([z.string(), z.null()]),
    notify: z.union([z.boolean(), z.null()]),
    task_due_minutes: z.union([z.number(), z.null()]),
    weekly_cap: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const SetAssignmentRepsBody = z
  .object({ reps: z.array(AssignmentRepInput) })
  .passthrough();
export const AssignmentJob = z
  .object({
    assigned: z.number().int(),
    created_at: z.string(),
    created_by: z.string(),
    error: z.union([z.string(), z.null()]).optional(),
    finished_at: z.union([z.string(), z.null()]).optional(),
    group_id: z.string(),
    group_name: z.string(),
    id: z.string(),
    processed: z.number().int(),
    status: z.string(),
    total: z.number().int(),
    unassigned: z.number().int(),
  })
  .passthrough();
export const AssignmentJobList = z
  .object({ jobs: z.array(AssignmentJob) })
  .passthrough();
export const FieldFilter = z
  .object({
    field: z.string(),
    operator: z.string(),
    value: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const LeadSearchBody = z
  .object({
    any_of: z.union([z.array(z.unknown()), z.null()]),
    attempted_buyer: z.union([z.string(), z.null()]),
    buyer: z.union([z.string(), z.null()]),
    buyer_ids: z.union([z.array(z.string()), z.null()]),
    campaign_id: z.union([z.string(), z.null()]),
    campaign_ids: z.union([z.array(z.string()), z.null()]),
    capture_methods: z.union([z.array(z.string()), z.null()]),
    date_from: z.union([z.string(), z.null()]),
    date_range: z.union([z.string(), z.null()]),
    date_to: z.union([z.string(), z.null()]),
    delivery_statuses: z.union([z.array(z.string()), z.null()]),
    destination_ids: z.union([z.array(z.string()), z.null()]),
    field_filters: z.union([z.array(FieldFilter), z.null()]),
    hlr_statuses: z.union([z.array(z.string()), z.null()]),
    ids: z.union([z.array(z.string()), z.null()]),
    ignore_campaign_filter: z.union([z.boolean(), z.null()]),
    import_ids: z.union([z.array(z.string()), z.null()]),
    lead_activities: z.union([z.array(z.string()), z.null()]),
    lead_method: z.union([z.string(), z.null()]),
    max_score: z.union([z.number(), z.null()]),
    max_value: z.union([z.number(), z.null()]),
    min_score: z.union([z.number(), z.null()]),
    min_value: z.union([z.number(), z.null()]),
    owner: z.union([z.string(), z.null()]),
    page: z.union([z.number(), z.null()]),
    page_size: z.union([z.number(), z.null()]),
    repeats_min: z.union([z.number(), z.null()]),
    score_band: z.union([z.string(), z.null()]),
    search: z.union([z.string(), z.null()]),
    sold_statuses: z.union([z.array(z.string()), z.null()]),
    sort: z.union([z.string(), z.null()]),
    source: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    supplier: z.union([z.string(), z.null()]),
    supplier_ids: z.union([z.array(z.string()), z.null()]),
  })
  .partial()
  .passthrough();
export const AssignPeopleBody = z
  .object({
    filter: z.union([z.null(), LeadSearchBody]).optional(),
    group_id: z.string(),
    person_ids: z.union([z.array(z.string()), z.null()]).optional(),
  })
  .passthrough();
export const AssignmentJobItem = z
  .object({
    person_id: z.string(),
    reason: z.string(),
    status: z.string(),
    user_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const AssignmentJobDetail = z
  .object({ job: AssignmentJob, not_assigned: z.array(AssignmentJobItem) })
  .passthrough();
export const AssistantStatus = z
  .object({
    available: z.boolean(),
    reason: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const AssistantMessage = z
  .object({ content: z.string(), role: z.string() })
  .passthrough();
export const AssistantChatBody = z
  .object({ messages: z.array(AssistantMessage) })
  .passthrough();
export const QueryStats = z
  .object({
    bytes_read: z.number().int().gte(0),
    elapsed_ms: z.number(),
    queries: z.number().int().gte(0),
    rows_read: z.number().int().gte(0),
  })
  .passthrough();
export const AssistantSource = z
  .object({ failed: z.boolean(), label: z.string(), tool: z.string() })
  .passthrough();
export const AssistantChatResponse = z
  .object({
    query_stats: z.union([z.null(), QueryStats]).optional(),
    reply: z.string(),
    sources: z.array(AssistantSource),
  })
  .passthrough();
export const AuditLogEntry = z
  .object({
    action: z.string(),
    created_at: z.string(),
    details: z.unknown().optional(),
    duration_ms: z.number().int(),
    http_method: z.string(),
    http_path: z.string(),
    http_status: z.number().int(),
    id: z.string(),
    ip_address: z.string(),
    resource_id: z.string(),
    resource_type: z.string(),
    user_email: z.string(),
    user_role: z.string(),
  })
  .passthrough();
export const AuditLogListResponse = z
  .object({
    logs: z.array(AuditLogEntry),
    next_before: z.union([z.string(), z.null()]).optional(),
    total: z.number().int(),
  })
  .passthrough();
export const FacetValue = z
  .object({ count: z.number().int(), value: z.string() })
  .passthrough();
export const AuditFacetsResponse = z
  .object({
    actions: z.array(FacetValue),
    methods: z.array(FacetValue),
    resource_types: z.array(FacetValue),
    users: z.array(FacetValue),
  })
  .passthrough();
export const StreamDoes = z
  .object({
    assigns: z.boolean(),
    buyers: z.number().int(),
    has_selling_routes: z.boolean(),
    sells: z.boolean(),
    sends: z.boolean(),
    stores_only: z.boolean(),
  })
  .passthrough();
export const CampaignSummary = z
  .object({
    active: z.boolean(),
    destination_count: z.number().int(),
    does: StreamDoes,
    group_count: z.number().int(),
    hash_format: z.string(),
    id: z.string(),
    is_reference_list: z.boolean(),
    name: z.string(),
    row_type: z.string(),
  })
  .passthrough();
export const MoneyPresence = z
  .object({
    any_stream_sells: z.boolean(),
    has_returns: z.boolean(),
    has_statements: z.boolean(),
  })
  .passthrough();
export const CampaignListResponse = z
  .object({ campaigns: z.array(CampaignSummary), money: MoneyPresence })
  .passthrough();
export const CreateCampaignBody = z
  .object({
    active: z.union([z.boolean(), z.null()]).optional(),
    description: z.union([z.string(), z.null()]).optional(),
    is_reference_list: z.union([z.boolean(), z.null()]).optional(),
    name: z.string(),
    row_type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CreateCampaignResponse = z
  .object({ api_key: z.string(), campaign_id: z.string() })
  .passthrough();
export const ArrivalChecks = z
  .object({
    about_a_person: z.boolean(),
    dedupe_api: z.boolean(),
    dedupe_import: z.boolean(),
    dedupe_lookback_days: z.number().int(),
    dedupe_set: z.boolean(),
    routes: z.number().int(),
    routes_with_phone_check: z.number().int(),
    routes_with_suppression: z.number().int(),
    suppression_lists: z.number().int(),
    suppression_on_error: z.string(),
  })
  .passthrough();
export const CampaignField = z
  .object({
    description: z.string().optional(),
    example: z.string().optional(),
    in_guide: z.boolean().optional(),
    name: z.string(),
    source_path: z.string().optional(),
    type: z.string().optional(),
  })
  .passthrough();
export const ActiveDaysResolution = z
  .object({
    destination_value: z.array(z.number().int()),
    source: z.string(),
    value: z.array(z.number().int()),
  })
  .passthrough();
export const PhoneCheckSettings = z
  .object({ accept_absent: z.boolean(), enabled: z.boolean() })
  .passthrough();
export const PriceResolution = z
  .object({
    buyer_settings_value: z.union([z.number(), z.null()]).optional(),
    destination_value: z.union([z.number(), z.null()]).optional(),
    link_value: z.number(),
    resolved: z.number(),
    source: z.string(),
  })
  .passthrough();
export const GroupDestination = z
  .object({
    active: z.boolean(),
    active_days: z.string(),
    buyer_id: z.string(),
    buyer_name: z.string(),
    caps: Caps,
    days: ActiveDaysResolution,
    delivery_method: z.string(),
    destination_id: z.string(),
    effective_caps: Caps,
    endpoint_url: z.string(),
    inherited_filter_count: z.number().int(),
    inherited_suppression_campaign_ids: z.array(z.string()),
    link_id: z.string(),
    method: z.string(),
    name: z.string(),
    own_caps: z.boolean(),
    phone_check: PhoneCheckSettings,
    price: PriceResolution,
    priority: z.number().int(),
    rate_limit: z.number().int(),
    smart_filters: z.unknown(),
    suppression_campaign_ids: z.array(z.string()),
    timeout_ms: z.number().int(),
    weight: z.number().int(),
  })
  .passthrough();
export const RouteGroup = z
  .object({
    active: z.boolean(),
    caps: Caps,
    delay_seconds: z.number().int(),
    delivery_count: z.number().int(),
    destinations: z.array(GroupDestination),
    distribution_method: z.string(),
    filters_enabled: z.boolean(),
    group_weight: z.number().int(),
    id: z.string(),
    name: z.string(),
    priority: z.number().int(),
    purpose: z.string(),
    smart_filters: z.unknown(),
    team_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CampaignSettings = z
  .object({
    dedupe_enabled: z.union([z.boolean(), z.null()]),
    dedupe_lookback_days: z.union([z.number(), z.null()]),
    default_delay: z.union([z.number(), z.null()]),
    max_attempts: z.union([z.number(), z.null()]),
    person_linking: z.union([z.string(), z.null()]),
    require_api_key: z.union([z.boolean(), z.null()]),
    row_type: z.union([z.string(), z.null()]),
    supplier_costs: z.union([z.record(z.number()), z.null()]),
    suppression_on_error: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CampaignDetailResponse = z
  .object({
    active: z.boolean(),
    api_key: z.union([z.string(), z.null()]).optional(),
    arrival_checks: ArrivalChecks,
    description: z.string(),
    does: StreamDoes,
    fields: z.array(CampaignField),
    groups: z.array(RouteGroup),
    hash_format: z.string(),
    id: z.string(),
    is_reference_list: z.boolean(),
    name: z.string(),
    row_type: z.string(),
    settings: CampaignSettings,
  })
  .passthrough();
export const UpdateCampaignBody = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    description: z.union([z.string(), z.null()]),
    hash_format: z.union([z.string(), z.null()]),
    is_reference_list: z.union([z.boolean(), z.null()]),
    name: z.union([z.string(), z.null()]),
    settings: z.union([z.null(), CampaignSettings]),
  })
  .partial()
  .passthrough();
export const UpdateCampaignResponse = z
  .object({ campaign_id: z.string(), changed: z.boolean() })
  .passthrough();
export const ResetApiKeyResponse = z
  .object({ api_key: z.string(), campaign_id: z.string() })
  .passthrough();
export const UpdateCampaignFieldsBody = z
  .object({ fields: z.array(CampaignField) })
  .passthrough();
export const CreateRouteGroupBody = z
  .object({
    delay_seconds: z.union([z.number(), z.null()]).optional(),
    delivery_count: z.union([z.number(), z.null()]).optional(),
    distribution_method: z.union([z.string(), z.null()]).optional(),
    filters_enabled: z.union([z.boolean(), z.null()]).optional(),
    group_daily_cap: z.union([z.number(), z.null()]).optional(),
    group_monthly_cap: z.union([z.number(), z.null()]).optional(),
    group_weekly_cap: z.union([z.number(), z.null()]).optional(),
    group_weight: z.union([z.number(), z.null()]).optional(),
    name: z.string(),
    priority: z.union([z.number(), z.null()]).optional(),
    smart_filters: z.union([z.array(z.unknown()), z.null()]).optional(),
  })
  .passthrough();
export const CreateRouteGroupResponse = z
  .object({ group_id: z.string() })
  .passthrough();
export const UpdateRouteGroupBody = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    delay_seconds: z.union([z.number(), z.null()]),
    delivery_count: z.union([z.number(), z.null()]),
    distribution_method: z.union([z.string(), z.null()]),
    filters_enabled: z.union([z.boolean(), z.null()]),
    group_daily_cap: z.union([z.number(), z.null()]),
    group_monthly_cap: z.union([z.number(), z.null()]),
    group_weekly_cap: z.union([z.number(), z.null()]),
    group_weight: z.union([z.number(), z.null()]),
    name: z.union([z.string(), z.null()]),
    priority: z.union([z.number(), z.null()]),
    smart_filters: z.union([z.array(z.unknown()), z.null()]),
  })
  .partial()
  .passthrough();
export const UpdateRouteGroupResponse = z
  .object({ changed: z.boolean(), group_id: z.string() })
  .passthrough();
export const LinkDestinationBody = z
  .object({
    buying_price: z.union([z.number(), z.null()]).optional(),
    daily_cap: z.union([z.number(), z.null()]).optional(),
    destination_id: z.string(),
    priority: z.union([z.number(), z.null()]).optional(),
    weight: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const UpdateGroupDestinationResponse = z
  .object({
    changed: z.boolean(),
    destination_id: z.string(),
    group_id: z.string(),
  })
  .passthrough();
export const UpdateGroupDestinationBody = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    active_days: z.union([z.array(z.number().int()), z.null()]),
    buying_price: z.union([z.number(), z.null()]),
    daily_cap: z.union([z.number(), z.null()]),
    inherit_active_days: z.union([z.boolean(), z.null()]),
    monthly_cap: z.union([z.number(), z.null()]),
    own_caps: z.union([z.boolean(), z.null()]),
    phone_check: z.union([z.boolean(), z.null()]),
    phone_check_accept_absent: z.union([z.boolean(), z.null()]),
    priority: z.union([z.number(), z.null()]),
    smart_filters: z.union([z.array(z.unknown()), z.null()]),
    suppression_campaign_ids: z.union([z.array(z.string()), z.null()]),
    weekly_cap: z.union([z.number(), z.null()]),
    weight: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const UnlinkDestinationResponse = z
  .object({
    destination_deleted: z.boolean(),
    destination_id: z.string(),
    group_id: z.string(),
  })
  .passthrough();
export const RoutingOutcome = z
  .object({ count: z.number().int(), result: z.string() })
  .passthrough();
export const RoutingReason = z
  .object({ count: z.number().int(), reason: z.string(), result: z.string() })
  .passthrough();
export const GroupOutcomes = z
  .object({
    accepted: z.number().int(),
    attempts: z.number().int(),
    group_id: z.string(),
    group_name: z.string(),
    outcomes: z.array(RoutingOutcome),
    reasons: z.array(RoutingReason),
    turned_away: z.number().int(),
  })
  .passthrough();
export const RoutingOutcomesResponse = z
  .object({
    date_range: z.string(),
    groups: z.array(GroupOutcomes),
    pre_routing: z.array(RoutingOutcome),
    total_attempts: z.number().int(),
  })
  .passthrough();
export const CompanyRoleLink = z
  .object({ active: z.boolean(), id: z.string(), name: z.string() })
  .passthrough();
export const CompanyRoleKey = z.enum(["data_buyer", "data_seller", "customer"]);
export const CompanyRole = z.enum(["partner", "source", "customer"]);
export const CompanySummary = z
  .object({
    buyer: z.union([z.null(), CompanyRoleLink]).optional(),
    created_at: z.string(),
    domain: z.string(),
    id: z.string(),
    name: z.string(),
    open_amount_pence: z.number().int(),
    open_deals: z.number().int(),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    phone: z.string(),
    properties: z.unknown(),
    role_keys: z.array(CompanyRoleKey),
    roles: z.array(CompanyRole),
    supplier: z.union([z.null(), CompanyRoleLink]).optional(),
    updated_at: z.string(),
  })
  .passthrough();
export const CompanyListResponse = z
  .object({ companies: z.array(CompanySummary), pagination: Pagination })
  .passthrough();
export const CreateCompanyBody = z
  .object({
    address: z.union([z.string(), z.null()]).optional(),
    domain: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    phone: z.union([z.string(), z.null()]).optional(),
    properties: z.unknown().optional(),
  })
  .passthrough();
export const CompanyDealTotals = z
  .object({
    lost_count: z.number().int(),
    open_amount_pence: z.number().int(),
    open_count: z.number().int(),
    won_amount_pence: z.number().int(),
    won_count: z.number().int(),
  })
  .passthrough();
export const DealStatus = z.enum(["open", "won", "lost"]);
export const DealSummary = z
  .object({
    amount_pence: z.number().int(),
    close_date: z.union([z.string(), z.null()]).optional(),
    company_id: z.union([z.string(), z.null()]).optional(),
    company_name: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    currency: z.string(),
    id: z.string(),
    name: z.string(),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    pipeline_id: z.string(),
    properties: z.unknown(),
    stage_entered_at: z.string(),
    stage_id: z.string(),
    stage_name: z.string(),
    status: DealStatus,
    updated_at: z.string(),
  })
  .passthrough();
export const CompanyDetail = z
  .object({
    address: z.string(),
    created_at: z.string(),
    deal_totals: CompanyDealTotals,
    domain: z.string(),
    id: z.string(),
    merged_into: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    open_deals: z.array(DealSummary),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    partner: z.union([z.null(), CompanyRoleLink]).optional(),
    phone: z.string(),
    properties: z.unknown(),
    role_keys: z.array(CompanyRoleKey),
    roles: z.array(CompanyRole),
    source: z.union([z.null(), CompanyRoleLink]).optional(),
    undefined_property_keys: z
      .union([z.array(z.string()), z.null()])
      .optional(),
    updated_at: z.string(),
  })
  .passthrough();
export const BulkOwnerBody = z
  .object({
    ids: z.array(z.string()),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const BulkOwnerSkip = z
  .object({ id: z.string(), reason: z.string() })
  .passthrough();
export const BulkOwnerResult = z
  .object({
    skipped: z.array(BulkOwnerSkip),
    updated: z.number().int(),
    updated_ids: z.array(z.string()),
  })
  .passthrough();
export const UpdateCompanyBody = z
  .object({
    address: z.union([z.string(), z.null()]),
    domain: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    owner_user_id: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    properties: z.unknown(),
  })
  .partial()
  .passthrough();
export const MergeCompanyBody = z
  .object({ other_company_id: z.string() })
  .passthrough();
export const CompanyMergeResult = z
  .object({
    company: CompanyDetail,
    moved_deals: z.number().int(),
    moved_partner: z.boolean(),
    moved_source: z.boolean(),
  })
  .passthrough();
export const RoleCampaign = z
  .object({
    id: z.string(),
    name: z.string(),
    rows_30d: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const RoleRouteLink = z
  .object({
    active: z.boolean(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    group_id: z.string(),
    group_name: z.string(),
    price: z.number(),
  })
  .passthrough();
export const RoleDestination = z
  .object({
    accepted_when: z.string(),
    active: z.boolean(),
    delivery_method: z.string(),
    id: z.string(),
    links: z.array(RoleRouteLink),
    name: z.string(),
  })
  .passthrough();
export const RoleFigures = z
  .object({
    cost: z.union([z.number(), z.null()]).optional(),
    return_rate: z.union([z.number(), z.null()]).optional(),
    returned: z.number().int(),
    revenue: z.union([z.number(), z.null()]).optional(),
    rows: z.union([z.number(), z.null()]).optional(),
    sold: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const CompanyRoleUse = z
  .object({
    campaign_costs: z.number().int(),
    destinations: z.number().int(),
    removable: z.boolean(),
    returns: z.number().int(),
    statements: z.number().int(),
  })
  .passthrough();
export const BuyerRoleActivity = z
  .object({
    active: z.boolean(),
    campaigns: z.array(RoleCampaign),
    destinations: z.array(RoleDestination),
    id: z.string(),
    last_30_days: RoleFigures,
    name: z.string(),
    own_return_window: z.boolean(),
    return_window_days: z.number().int(),
    usage: CompanyRoleUse,
  })
  .passthrough();
export const SupplierCampaignCost = z
  .object({
    amount: z.number(),
    campaign_id: z.string(),
    campaign_name: z.string(),
  })
  .passthrough();
export const SupplierRoleActivity = z
  .object({
    active: z.boolean(),
    campaign_costs: z.array(SupplierCampaignCost),
    campaigns: z.array(RoleCampaign),
    id: z.string(),
    last_30_days: RoleFigures,
    name: z.string(),
    usage: CompanyRoleUse,
  })
  .passthrough();
export const CompanyRoleActivity = z
  .object({
    buyer: z.union([z.null(), BuyerRoleActivity]).optional(),
    company_id: z.string(),
    supplier: z.union([z.null(), SupplierRoleActivity]).optional(),
  })
  .passthrough();
export const AddCompanyRoleBody = z.object({ role: CompanyRoleKey }).passthrough();
export const NamedCount = z
  .object({ count: z.number().int(), name: z.string() })
  .passthrough();
export const HourlyPoint = z
  .object({ count: z.number().int(), hour: z.number().int() })
  .passthrough();
export const TimeSeriesPoint = z
  .object({ count: z.number().int(), date: z.string() })
  .passthrough();
export const MoneyVisibility = z
  .object({ cost: z.boolean(), margin: z.boolean(), revenue: z.boolean() })
  .passthrough();
export const RevenuePoint = z
  .object({ date: z.string(), revenue: z.number() })
  .passthrough();
export const TopCampaign = z
  .object({
    campaign_id: z.string(),
    campaign_name: z.string(),
    leads: z.number().int(),
    qualified: z.number().int(),
    revenue: z.number(),
  })
  .passthrough();
export const DashboardStatsResponse = z
  .object({
    active_campaigns: z.number().int(),
    conversion_change: z.number(),
    conversion_rate: z.number(),
    cost_change: z.number(),
    delivery_breakdown: z.array(NamedCount),
    hourly_distribution: z.array(HourlyPoint),
    lead_performance: z.array(TimeSeriesPoint),
    lead_sources: z.array(NamedCount),
    leads_change: z.number(),
    margin: z.union([z.number(), z.null()]).optional(),
    margin_pct: z.union([z.number(), z.null()]).optional(),
    money: MoneyVisibility,
    qualified_leads: z.number().int(),
    revenue_change: z.number(),
    revenue_performance: z.array(RevenuePoint),
    top_campaigns: z.array(TopCampaign),
    total_cost: z.number(),
    total_leads: z.number().int(),
    total_revenue: z.number(),
  })
  .passthrough();
export const DealListResponse = z
  .object({
    deals: z.array(DealSummary),
    pagination: Pagination,
    total_amount_pence: z.number().int(),
  })
  .passthrough();
export const DealPerson = z
  .object({ person_ref: z.string(), role: z.string() })
  .passthrough();
export const CreateDealBody = z
  .object({
    amount_pence: z.union([z.number(), z.null()]).optional(),
    close_date: z.union([z.string(), z.null()]).optional(),
    company_id: z.union([z.string(), z.null()]).optional(),
    currency: z.union([z.string(), z.null()]).optional(),
    lost_reason: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    people: z.union([z.array(DealPerson), z.null()]).optional(),
    pipeline_id: z.union([z.string(), z.null()]).optional(),
    primary_person_ref: z.union([z.string(), z.null()]).optional(),
    properties: z.unknown().optional(),
    source_submission_id: z.union([z.string(), z.null()]).optional(),
    stage_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const DealStageChange = z
  .object({
    at: z.string(),
    by_name: z.union([z.string(), z.null()]).optional(),
    by_user_id: z.string(),
    from_stage_id: z.union([z.string(), z.null()]).optional(),
    from_stage_name: z.union([z.string(), z.null()]).optional(),
    note: z.union([z.string(), z.null()]).optional(),
    to_stage_id: z.string(),
    to_stage_name: z.string(),
  })
  .passthrough();
export const StageKind = z.enum(["open", "won", "lost"]);
export const DealDetail = z
  .object({
    amount_pence: z.number().int(),
    close_date: z.union([z.string(), z.null()]).optional(),
    company_id: z.union([z.string(), z.null()]).optional(),
    company_name: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    created_by: z.string(),
    currency: z.string(),
    history: z.array(DealStageChange),
    id: z.string(),
    lost_reason: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    people: z.array(DealPerson),
    pipeline_id: z.string(),
    pipeline_name: z.string(),
    primary_person_ref: z.union([z.string(), z.null()]).optional(),
    properties: z.unknown(),
    source_submission_id: z.union([z.string(), z.null()]).optional(),
    stage_entered_at: z.string(),
    stage_id: z.string(),
    stage_kind: StageKind,
    stage_name: z.string(),
    status: DealStatus,
    undefined_property_keys: z
      .union([z.array(z.string()), z.null()])
      .optional(),
    updated_at: z.string(),
  })
  .passthrough();
export const OwnerTotals = z
  .object({
    open_amount_pence: z.number().int(),
    open_count: z.number().int(),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    weighted_pence: z.number().int(),
    won_amount_pence: z.number().int(),
    won_count: z.number().int(),
  })
  .passthrough();
export const StageTotals = z
  .object({
    amount_pence: z.number().int(),
    archived: z.boolean(),
    count: z.number().int(),
    kind: StageKind,
    name: z.string(),
    position: z.number().int(),
    stage_id: z.string(),
    weighted_pence: z.number().int(),
    win_probability: z.number().int(),
  })
  .passthrough();
export const DealsSummaryResponse = z
  .object({
    open_amount_pence: z.number().int(),
    open_count: z.number().int(),
    owners: z.array(OwnerTotals),
    pipeline_id: z.string(),
    stages: z.array(StageTotals),
    weighted_pence: z.number().int(),
    won_amount_pence: z.number().int(),
    won_count: z.number().int(),
  })
  .passthrough();
export const UpdateDealBody = z
  .object({
    amount_pence: z.union([z.number(), z.null()]),
    close_date: z.union([z.string(), z.null()]),
    company_id: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    owner_user_id: z.union([z.string(), z.null()]),
    people: z.union([z.array(DealPerson), z.null()]),
    primary_person_ref: z.union([z.string(), z.null()]),
    properties: z.unknown(),
  })
  .partial()
  .passthrough();
export const MoveDealBody = z
  .object({
    reason: z.union([z.string(), z.null()]).optional(),
    stage_id: z.string(),
  })
  .passthrough();
export const Destination = z
  .object({
    active: z.boolean(),
    buyer_id: z.string(),
    buyer_name: z.string(),
    delivery_method: z.string(),
    endpoint_url: z.string(),
    id: z.string(),
    link_count: z.number().int(),
    method: z.string(),
    name: z.string(),
    ping_endpoint: z.string(),
    post_endpoint: z.string(),
    timeout_ms: z.number().int(),
  })
  .passthrough();
export const DestinationListResponse = z
  .object({ destinations: z.array(Destination) })
  .passthrough();
export const AcceptRule = z
  .object({
    operator: z.string(),
    path: z.string().optional(),
    value: z.unknown().optional(),
  })
  .passthrough();
export const Acceptance = z
  .object({
    buyer_lead_id_path: z.union([z.string(), z.null()]),
    ping_rules: z.array(AcceptRule),
    price_path: z.union([z.string(), z.null()]),
    reject_reason_path: z.union([z.string(), z.null()]),
    rules: z.array(AcceptRule),
    use_response_price: z.boolean(),
  })
  .partial()
  .passthrough();
export const ConfigPair = z
  .object({ key: z.string(), value: z.string() })
  .passthrough();
export const DestinationConfig = z
  .object({
    acceptance: z.union([z.null(), Acceptance]),
    headers: z.array(ConfigPair),
    import_concurrency: z.union([z.number(), z.null()]),
    query_params: z.array(ConfigPair),
  })
  .partial()
  .passthrough();
export const UpsertDestinationBody = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    active_days: z.union([z.array(z.number().int()), z.null()]),
    buyer_id: z.union([z.string(), z.null()]),
    config: z.union([z.null(), DestinationConfig]),
    delivery_method: z.union([z.string(), z.null()]),
    endpoint_url: z.union([z.string(), z.null()]),
    method: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    ping_endpoint: z.union([z.string(), z.null()]),
    post_endpoint: z.union([z.string(), z.null()]),
    timeout_ms: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const UpsertDestinationResponse = z
  .object({ destination_id: z.string() })
  .passthrough();
export const AcceptanceCheckBody = z
  .object({
    acceptance: Acceptance,
    ping: z.boolean().optional(),
    response_body: z.string(),
    status: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const RuleCheck = z
  .object({
    found: z.union([z.string(), z.null()]).optional(),
    passed: z.boolean(),
    rule: z.string(),
  })
  .passthrough();
export const Verdict = z
  .object({
    accepted: z.boolean(),
    buyer_lead_id: z.union([z.string(), z.null()]).optional(),
    buyer_reason: z.union([z.string(), z.null()]).optional(),
    checked: z.boolean(),
    checks: z.array(RuleCheck),
    price_from_response: z.boolean(),
    reason: z.union([z.string(), z.null()]).optional(),
    response_price: z.union([z.number(), z.null()]).optional(),
    stage: z.string(),
    status: z.number().int().gte(0),
  })
  .passthrough();
export const AcceptanceCheckResponse = z
  .object({
    invalid: z.union([z.string(), z.null()]).optional(),
    verdict: Verdict,
  })
  .passthrough();
export const TestDestinationBody = z
  .object({
    acceptance: z.union([z.null(), Acceptance]).optional(),
    body: z.union([z.string(), z.null()]).optional(),
    headers: z.union([z.array(ConfigPair), z.null()]).optional(),
    method: z.union([z.string(), z.null()]).optional(),
    timeout_ms: z.union([z.number(), z.null()]).optional(),
    url: z.string(),
  })
  .passthrough();
export const TestDestinationResponse = z
  .object({
    duration_ms: z.number().int(),
    error: z.union([z.string(), z.null()]).optional(),
    ok: z.boolean(),
    response_body: z.string(),
    status: z.union([z.number(), z.null()]).optional(),
    verdict: z.union([z.null(), Verdict]).optional(),
  })
  .passthrough();
export const LegacyResponseSettings = z
  .object({
    error_path: z.union([z.string(), z.null()]),
    success_path: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DestinationDetailResponse = z
  .object({
    active: z.boolean(),
    active_days: z.array(z.number().int()),
    buyer_id: z.string(),
    buyer_name: z.string(),
    config: DestinationConfig,
    delivery_method: z.string(),
    endpoint_url: z.string(),
    id: z.string(),
    inheriting_link_count: z.number().int(),
    legacy_response: z.union([z.null(), LegacyResponseSettings]).optional(),
    link_count: z.number().int(),
    method: z.string(),
    name: z.string(),
    ping_endpoint: z.string(),
    post_endpoint: z.string(),
    timeout_ms: z.number().int(),
  })
  .passthrough();
export const DestinationBuyerChangeLink = z
  .object({
    buyer_already_in_group: z.boolean(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    group_id: z.string(),
    group_name: z.string(),
    live: z.boolean(),
    price_after: PriceResolution,
    price_changes: z.boolean(),
    price_now: PriceResolution,
  })
  .passthrough();
export const DestinationBuyerChangeResponse = z
  .object({
    buyer_id: z.string(),
    buyer_name: z.string(),
    current_buyer_id: z.string(),
    current_buyer_name: z.string(),
    destination_id: z.string(),
    links: z.array(DestinationBuyerChangeLink),
  })
  .passthrough();
export const RegisterDeviceTokenBody = z
  .object({ platform: z.string().optional(), token: z.string() })
  .passthrough();
export const EmailBrand = z
  .object({
    daily_cap: z.number().int(),
    from_email: z.string(),
    from_name: z.string(),
    id: z.string(),
    name: z.string(),
    reply_to: z.string(),
    unsubscribe_domain: z.string(),
    warmup: z.array(z.number().int()),
    website: z.string(),
  })
  .passthrough();
export const EmailBrandListResponse = z
  .object({ brands: z.array(EmailBrand) })
  .passthrough();
export const EmailBrandBody = z
  .object({
    daily_cap: z.number().int().optional(),
    from_email: z.string().optional(),
    from_name: z.string().optional(),
    name: z.string(),
    reply_to: z.string().optional(),
    unsubscribe_domain: z.string().optional(),
    warmup: z.array(z.number().int()).optional(),
    website: z.string().optional(),
  })
  .passthrough();
export const EmailTemplateWriteResponse = z
  .object({ id: z.string(), updated_at: z.string() })
  .passthrough();
export const EmailAudience = z
  .object({
    campaign_ids: z.array(z.string()),
    filters: z.array(z.object({}).partial().passthrough()),
    since_days: z.number().int(),
  })
  .partial()
  .passthrough();
export const EmailCampaign = z
  .object({
    audience: EmailAudience,
    brand_id: z.string(),
    brand_name: z.string(),
    cap_today: z.number().int(),
    converted_to: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    created_by: z.string(),
    daily_cap: z.number().int(),
    delay_minutes: z.number().int(),
    expire_hours: z.number().int(),
    expired: z.number().int(),
    finished_at: z.string(),
    id: z.string(),
    kind: z.string(),
    name: z.string(),
    queued: z.number().int(),
    scheduled_at: z.string(),
    sent: z.number().int(),
    skipped_invalid: z.number().int(),
    skipped_unverified: z.number().int(),
    started_at: z.string(),
    status: z.string(),
    template_id: z.string(),
    template_name: z.string(),
    updated_at: z.string(),
    verify_job_id: z.string(),
    verify_status: z.string(),
    warmup: z.array(z.number().int()),
  })
  .passthrough();
export const EmailCampaignListResponse = z
  .object({ campaigns: z.array(EmailCampaign) })
  .passthrough();
export const ElvCreditsView = z
  .object({
    on_demand: z.number().int(),
    subscription: z.number().int(),
    subscription_expires: z.string(),
    total: z.number().int(),
  })
  .passthrough();
export const EmailSuppressionCounts = z
  .object({
    bounce: z.number().int(),
    complaint: z.number().int(),
    invalid: z.number().int(),
    manual: z.number().int(),
    sunset: z.number().int(),
    total: z.number().int(),
    unsubscribe: z.number().int(),
  })
  .passthrough();
export const EmailRateThresholds = z
  .object({
    bounce_amber: z.number(),
    bounce_red: z.number(),
    complaint_amber: z.number(),
    complaint_red: z.number(),
  })
  .passthrough();
export const EmailVerificationCount = z
  .object({ count: z.number().int(), decision: z.string(), status: z.string() })
  .passthrough();
export const EmailHygieneResponse = z
  .object({
    bounce_level: z.string(),
    bounce_rate: z.number(),
    complaint_level: z.string(),
    complaint_rate: z.number(),
    complaints_30d: z.number().int(),
    credits: z.union([z.null(), ElvCreditsView]).optional(),
    credits_error: z.string(),
    elv_configured: z.boolean(),
    hard_bounces_30d: z.number().int(),
    sent_30d: z.number().int(),
    skipped_invalid_30d: z.number().int(),
    skipped_unverified_30d: z.number().int(),
    soft_bounces_30d: z.number().int(),
    sunset_7d: z.number().int(),
    suppressions: EmailSuppressionCounts,
    thresholds: EmailRateThresholds,
    verification: z.array(EmailVerificationCount),
    verified_30d: z.number().int(),
  })
  .passthrough();
export const EmailStatTotals = z
  .object({
    bounced: z.number().int(),
    clicked: z.number().int(),
    complained: z.number().int(),
    delivered: z.number().int(),
    failed: z.number().int(),
    opened: z.number().int(),
    sent: z.number().int(),
    unsubscribed: z.number().int(),
  })
  .passthrough();
export const EmailCampaignStats = z
  .object({
    campaign_id: z.string(),
    name: z.union([z.string(), z.null()]).optional(),
    totals: EmailStatTotals,
    workflow_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const EmailStatDay = z
  .object({
    bounced: z.number().int(),
    clicked: z.number().int(),
    day: z.string(),
    opened: z.number().int(),
    sent: z.number().int(),
  })
  .passthrough();
export const EmailHealth = z
  .object({
    account_error: z.string(),
    bounce_rate: z.number(),
    complaint_rate: z.number(),
    events_connected: z.boolean(),
    max_24h: z.number(),
    max_rate: z.number(),
    production: z.union([z.boolean(), z.null()]).optional(),
    sent_24h: z.number(),
  })
  .passthrough();
export const EmailStatsResponse = z
  .object({
    campaigns: z.array(EmailCampaignStats),
    daily: z.array(EmailStatDay),
    health: EmailHealth,
    previous: EmailStatTotals,
    range: z.string(),
    totals: EmailStatTotals,
  })
  .passthrough();
export const EmailSuppression = z
  .object({
    campaign_name: z.string(),
    created_at: z.string(),
    reason: z.string(),
  })
  .passthrough();
export const EmailSuppressionListResponse = z
  .object({
    bounces: z.number().int(),
    complaints: z.number().int(),
    invalid: z.number().int(),
    manual: z.number().int(),
    recent: z.array(EmailSuppression),
    sunset: z.number().int(),
    total: z.number().int(),
    unsubscribes: z.number().int(),
  })
  .passthrough();
export const EmailAddressBody = z.object({ email: z.string() }).passthrough();
export const EmailSuppressionCheckResponse = z
  .object({
    created_at: z.string(),
    reason: z.string(),
    suppressed: z.boolean(),
  })
  .passthrough();
export const EmailTemplateSummary = z
  .object({
    created_by: z.string(),
    id: z.string(),
    kind: z.string(),
    name: z.string(),
    subject: z.string(),
    updated_at: z.string(),
  })
  .passthrough();
export const EmailTemplateListResponse = z
  .object({ templates: z.array(EmailTemplateSummary) })
  .passthrough();
export const CreateEmailTemplateBody = z
  .object({
    copy_from: z.union([z.string(), z.null()]).optional(),
    kind: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
  })
  .passthrough();
export const EmailTemplate = z
  .object({
    created_at: z.string(),
    created_by: z.string(),
    design: z.string(),
    from_email: z.string(),
    from_name: z.string(),
    html: z.string(),
    id: z.string(),
    kind: z.string(),
    name: z.string(),
    preview_text: z.string(),
    reply_to: z.string(),
    subject: z.string(),
    text_body: z.string(),
    updated_at: z.string(),
  })
  .passthrough();
export const UpdateEmailTemplateBody = z
  .object({
    design: z.union([z.string(), z.null()]),
    from_email: z.union([z.string(), z.null()]),
    from_name: z.union([z.string(), z.null()]),
    html: z.union([z.string(), z.null()]),
    kind: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    preview_text: z.union([z.string(), z.null()]),
    reply_to: z.union([z.string(), z.null()]),
    subject: z.union([z.string(), z.null()]),
    text_body: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const EmailAiEditBody = z
  .object({
    design: z.union([z.string(), z.null()]).optional(),
    history: z.array(z.string()).optional(),
    html: z.union([z.string(), z.null()]).optional(),
    instruction: z.string(),
    kind: z.string(),
    preview_text: z.string().optional(),
    subject: z.string().optional(),
    variables: z.array(z.string()).optional(),
  })
  .passthrough();
export const EmailAiEditResponse = z
  .object({
    design: z.union([z.string(), z.null()]).optional(),
    html: z.union([z.string(), z.null()]).optional(),
    preview_text: z.union([z.string(), z.null()]).optional(),
    subject: z.union([z.string(), z.null()]).optional(),
    summary: z.string(),
  })
  .passthrough();
export const EmailTemplateLink = z
  .object({
    name: z.union([z.string(), z.null()]).optional(),
    text: z.string(),
    url: z.string(),
  })
  .passthrough();
export const EmailTemplateLinksResponse = z
  .object({
    links: z.array(EmailTemplateLink),
    template_id: z.string(),
    template_name: z.string(),
  })
  .passthrough();
export const SendTestEmailBody = z
  .object({ to: z.string(), values: z.record(z.string()).optional() })
  .passthrough();
export const SendTestEmailResponse = z
  .object({ message_id: z.string() })
  .passthrough();
export const EmailVerifyJobView = z
  .object({
    campaign_id: z.string(),
    created_at: z.string(),
    credits_estimate: z.number().int(),
    error: z.string(),
    free_failed: z.number().int(),
    fresh: z.number().int(),
    id: z.string(),
    invalid: z.number().int(),
    mode: z.string(),
    phase: z.string(),
    progress: z.number().int(),
    status: z.string(),
    subject: z.string(),
    to_verify: z.number().int(),
    total: z.number().int(),
    updated_at: z.string(),
    verified: z.number().int(),
  })
  .passthrough();
export const Entity = z
  .object({
    active: z.boolean(),
    company_id: z.union([z.string(), z.null()]).optional(),
    company_name: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    email: z.string(),
    id: z.string(),
    name: z.string(),
    phone: z.string(),
    settings: z.unknown(),
  })
  .passthrough();
export const EntityListResponse = z
  .object({ entities: z.array(Entity) })
  .passthrough();
export const EntityBody = z
  .object({
    active: z.union([z.boolean(), z.null()]).optional(),
    email: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    phone: z.union([z.string(), z.null()]).optional(),
    settings: z.unknown().optional(),
  })
  .passthrough();
export const PersonBrief = z
  .object({
    email: z.string(),
    id: z.string(),
    last_seen: z.string(),
    name: z.string(),
    phone: z.string(),
    submissions: z.number().int(),
  })
  .passthrough();
export const IdentitySuggestion = z
  .object({
    candidate: PersonBrief,
    created_at: z.string(),
    id: z.string(),
    person: PersonBrief,
    rule: z.string(),
    status: z.string(),
    submission_id: z.string(),
  })
  .passthrough();
export const SuggestionListResponse = z
  .object({ pagination: Pagination, suggestions: z.array(IdentitySuggestion) })
  .passthrough();
export const SuggestionDecisionBody = z
  .object({ action: z.string(), ids: z.array(z.string()) })
  .passthrough();
export const SuggestionDecisionResponse = z
  .object({
    accepted: z.number().int(),
    dismissed: z.number().int(),
    link_ids: z.array(z.string()),
    skipped: z.number().int(),
  })
  .passthrough();
export const ImportSampleInfo = z
  .object({
    limit: z.number().int().default(0),
    rest_available: z.boolean().default(false),
    rest_job_id: z.union([z.string(), z.null()]).default(null),
    rows_left: z.union([z.number(), z.null()]).default(null),
  })
  .partial()
  .passthrough();
export const ImportReason = z
  .object({ count: z.number().int(), reason: z.string() })
  .passthrough();
export const ImportLive = z
  .object({
    accepted: z.number().int().default(0),
    capped: z.number().int().default(0),
    distribute: z.boolean().default(false),
    duplicate: z.number().int().default(0),
    elapsed_seconds: z.union([z.number(), z.null()]).default(null),
    eta_seconds: z.union([z.number(), z.null()]).default(null),
    filtered: z.number().int().default(0),
    lost: z.number().int().default(0),
    other: z.number().int().default(0),
    progress: z.number().int().default(0),
    rate_per_sec: z.union([z.number(), z.null()]).default(null),
    rejected: z.number().int().default(0),
    rows_imported: z.number().int().default(0),
    rows_processed: z.number().int().default(0),
    rows_skipped: z.number().int().default(0),
    rows_total: z.number().int().default(0),
    sample: z.union([z.null(), ImportSampleInfo]).default(null),
    step: z.union([z.string(), z.null()]).default(null),
    suppressed: z.number().int().default(0),
    top_rejection: z.union([z.null(), ImportReason]).default(null),
    top_rejections: z.array(ImportReason).default([]),
  })
  .partial()
  .passthrough();
export const ImportJob = z
  .object({
    campaign_id: z.string(),
    campaign_name: z.string(),
    can_resume: z.boolean(),
    completed_at: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    error_message: z.union([z.string(), z.null()]).optional(),
    file_name: z.string(),
    hlr_enabled: z.boolean(),
    job_id: z.string(),
    live: z.union([z.null(), ImportLive]).optional(),
    processing_started_at: z.union([z.string(), z.null()]).optional(),
    rows_duplicate: z.union([z.number(), z.null()]).optional(),
    rows_hlr_rejected: z.union([z.number(), z.null()]).optional(),
    rows_imported: z.union([z.number(), z.null()]).optional(),
    rows_invalid: z.union([z.number(), z.null()]).optional(),
    rows_total: z.union([z.number(), z.null()]).optional(),
    status: z.string(),
    stop_reason: z.union([z.string(), z.null()]).optional(),
    user_email: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ImportListResponse = z
  .object({ imports: z.array(ImportJob), pagination: Pagination })
  .passthrough();
export const StartImportRequest = z
  .object({
    campaign_id: z.string(),
    column_mapping: z.record(z.string()),
    csv_headers: z.union([z.array(z.string()), z.null()]).optional(),
    distribute: z.boolean().optional(),
    email_enabled: z.boolean().optional(),
    file_key: z.string(),
    file_name: z.union([z.string(), z.null()]).optional(),
    hlr_enabled: z.boolean().optional(),
    row_limit: z.union([z.number(), z.null()]).optional(),
    total_rows: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const StartImportResponse = z.object({ job_id: z.string() }).passthrough();
export const ImportPreflightBody = z
  .object({
    campaign_id: z.string(),
    column_mapping: z.record(z.string()).optional(),
    file_name: z.union([z.string(), z.null()]).optional(),
    file_size: z.union([z.number(), z.null()]).optional(),
    sheet_id: z.union([z.string(), z.null()]).optional(),
    total_rows: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const PreflightPrevious = z
  .object({
    created_at: z.string(),
    file_name: z.string(),
    job_id: z.string(),
    rows_imported: z.union([z.number(), z.null()]).optional(),
    rows_total: z.union([z.number(), z.null()]).optional(),
    status: z.string(),
  })
  .passthrough();
export const PreflightRoute = z
  .object({
    buyer_name: z.string(),
    concurrency: z.number().int(),
    group_name: z.string(),
    route_id: z.string(),
    route_name: z.string(),
  })
  .passthrough();
export const ImportPreflightResponse = z
  .object({
    does: StreamDoes,
    estimated_seconds: z.union([z.number(), z.null()]).optional(),
    maps_email: z.boolean(),
    maps_phone: z.boolean(),
    previous: z.array(PreflightPrevious),
    rate_per_sec: z.number(),
    rate_source: z.string(),
    routes: z.array(PreflightRoute),
  })
  .passthrough();
export const ImportTestSendBody = z.object({ campaign_id: z.string() }).passthrough();
export const TestSendResult = z
  .object({
    accepted: z.boolean(),
    buyer_name: z.string(),
    duration_ms: z.number().int(),
    error: z.union([z.string(), z.null()]).optional(),
    reason: z.union([z.string(), z.null()]).optional(),
    reply: z.string(),
    route_id: z.string(),
    route_name: z.string(),
    status: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const ImportTestSendResponse = z
  .object({ all_accepted: z.boolean(), results: z.array(TestSendResult) })
  .passthrough();
export const ImportProgress = ImportJob.and(
  z
    .object({
      in_progress: z.boolean(),
      percent: z.union([z.number(), z.null()]).optional(),
    })
    .passthrough()
);
export const ImportActionResponse = z
  .object({ cancelling: z.boolean(), job_id: z.string(), status: z.string() })
  .passthrough();
export const LeadField = z
  .object({
    built_in: z.boolean(),
    computed: z.boolean(),
    coverage: z.number(),
    declared: z.boolean(),
    key: z.string(),
    last_seen: z.union([z.string(), z.null()]).optional(),
    leads_with: z.number().int(),
    property: z.boolean(),
  })
  .passthrough();
export const LeadFieldsResponse = z
  .object({
    campaign_ids: z.array(z.string()),
    capped: z.boolean(),
    days: z.number().int(),
    fields: z.array(LeadField),
    query_stats: z.union([z.null(), QueryStats]).optional(),
    sample_limit: z.number().int(),
    sample_rows: z.number().int(),
  })
  .passthrough();
export const LeadFieldPreviewBody = z
  .object({
    campaign_id: z.string(),
    days: z.union([z.number(), z.null()]).optional(),
    filters: z.unknown(),
  })
  .passthrough();
export const LeadFieldPreviewReason = z
  .object({ count: z.number().int(), reason: z.string() })
  .passthrough();
export const LeadFieldPreviewResponse = z
  .object({
    blocked: z.number().int(),
    capped: z.boolean(),
    days: z.number().int(),
    query_stats: z.union([z.null(), QueryStats]).optional(),
    reasons: z.array(LeadFieldPreviewReason),
    sample_limit: z.number().int(),
    sample_rows: z.number().int(),
    skipped_types: z.array(z.string()),
  })
  .passthrough();
export const LeadFieldValue = z
  .object({ count: z.number().int(), value: z.string() })
  .passthrough();
export const LeadFieldValuesResponse = z
  .object({
    capped: z.boolean(),
    days: z.number().int(),
    field: z.string(),
    query_stats: z.union([z.null(), QueryStats]).optional(),
    sample_limit: z.number().int(),
    sample_rows: z.number().int(),
    values: z.array(LeadFieldValue),
  })
  .passthrough();
export const ScoreBandRef = z
  .object({ colour: z.string(), key: z.string(), label: z.string() })
  .passthrough();
export const LeadSummary = z
  .object({
    buyer_id: z.string(),
    buyer_name: z.string(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    company: z.string(),
    created_at: z.string(),
    delivery_status: z.string(),
    email: z.string(),
    firstname: z.string(),
    fullname: z.string(),
    id: z.string(),
    lastname: z.string(),
    other_submissions: z.union([z.number(), z.null()]).optional(),
    payout: z.number(),
    person_id: z.union([z.string(), z.null()]).optional(),
    phone1: z.string(),
    revenue: z.number(),
    score: z.union([z.number(), z.null()]).optional(),
    score_band: z.union([z.null(), ScoreBandRef]).optional(),
    sold: z.boolean(),
    source: z.string(),
    status: z.string(),
    supplier_id: z.string(),
    supplier_name: z.string(),
  })
  .passthrough();
export const LeadListResponse = z
  .object({
    leads: z.array(LeadSummary),
    pagination: Pagination,
    query_stats: z.union([z.null(), QueryStats]).optional(),
    total_revenue: z.number(),
  })
  .passthrough();
export const LeadCustomKeysResponse = z
  .object({
    campaign_ids: z.array(z.string()),
    defined: z.array(z.string()),
    keys: z.array(z.string()),
    query_stats: z.union([z.null(), QueryStats]).optional(),
  })
  .passthrough();
export const LeadFacetsResponse = z
  .object({ sources: z.array(z.string()), suppliers: z.array(z.string()) })
  .passthrough();
export const InsightsOverall = z
  .object({
    avg_revenue: z.number(),
    max_revenue: z.number(),
    min_revenue: z.number(),
    total_leads: z.number().int(),
    total_revenue: z.number(),
  })
  .passthrough();
export const InsightsRow = z
  .object({
    avg_revenue: z.number(),
    label: z.string(),
    leads: z.number().int(),
    revenue: z.number(),
  })
  .passthrough();
export const InsightsResponse = z
  .object({
    overall: InsightsOverall,
    query_stats: z.union([z.null(), QueryStats]).optional(),
    rows: z.array(InsightsRow),
  })
  .passthrough();
export const RedistributeBody = z
  .object({
    lead_ids: z.array(z.string()),
    skip_active_days: z.boolean().optional(),
    skip_buyer_dedupe: z.boolean().optional(),
    skip_caps: z.boolean().optional(),
    skip_filters: z.boolean().optional(),
    skip_suppression: z.boolean().optional(),
  })
  .passthrough();
export const RedistributeResponse = z
  .object({
    errors: z.array(z.string()),
    in_progress: z.array(z.string()),
    queued: z.number().int().gte(0),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const LeadSearchInterpretStatus = z
  .object({ available: z.boolean() })
  .passthrough();
export const LeadSearchInterpretBody = z.object({ text: z.string() }).passthrough();
export const LeadSearchInterpretResponse = z
  .object({ query: z.string(), unknown: z.array(z.string()) })
  .passthrough();
export const SegmentCountInput = z
  .object({ filter_state: LeadSearchBody, id: z.number().int() })
  .passthrough();
export const SegmentCountsBody = z
  .object({
    segments: z.array(SegmentCountInput),
    unit: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SegmentCount = z
  .object({
    id: z.number().int(),
    people: z.union([z.number(), z.null()]).optional(),
    total: z.number().int(),
  })
  .passthrough();
export const SegmentCountsResponse = z
  .object({
    counts: z.array(SegmentCount),
    query_stats: z.union([z.null(), QueryStats]).optional(),
  })
  .passthrough();
export const DistributionAttempt = z
  .object({
    buyer_id: z.union([z.string(), z.null()]).optional(),
    buyer_name: z.union([z.string(), z.null()]).optional(),
    delivery_method: z.union([z.string(), z.null()]).optional(),
    error_message: z.union([z.string(), z.null()]).optional(),
    filter_reason: z.union([z.string(), z.null()]).optional(),
    group_id: z.union([z.string(), z.null()]).optional(),
    group_name: z.union([z.string(), z.null()]).optional(),
    price: z.union([z.number(), z.null()]).optional(),
    reason: z.string(),
    response_body: z.union([z.string(), z.null()]).optional(),
    response_time_ms: z.number().int(),
    result: z.string(),
    route_id: z.union([z.string(), z.null()]).optional(),
    route_name: z.union([z.string(), z.null()]).optional(),
    sent_data: z.unknown().optional(),
  })
  .passthrough();
export const DuplicateInfo = z
  .object({
    matched_field: z.union([z.string(), z.null()]),
    previous_buyer_name: z.union([z.string(), z.null()]),
    previous_lead_date: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const PhoneCheck = z
  .object({
    line_type: z.union([z.string(), z.null()]).optional(),
    live: z.boolean(),
    network: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    test: z.boolean(),
  })
  .passthrough();
export const DistributionSummary = z
  .object({
    duplicate_info: z.union([z.null(), DuplicateInfo]).optional(),
    payout: z.number(),
    phone_check: z.union([z.null(), PhoneCheck]).optional(),
    routing: z.array(z.string()),
    routing_recorded: z.boolean(),
    sold: z.boolean(),
    sold_to: z.array(z.string()),
    total_attempts: z.number().int(),
    total_groups: z.number().int(),
    total_time_ms: z.number().int(),
  })
  .passthrough();
export const PropertyType = z.enum([
  "text",
  "long_text",
  "number",
  "currency",
  "date",
  "datetime",
  "select",
  "multi_select",
  "boolean",
  "user",
  "email",
  "phone",
  "url",
]);
export const SubmissionProperty = z
  .object({
    group_name: z.string(),
    key: z.string(),
    label: z.string(),
    raw: z.string(),
    type: PropertyType,
    valid: z.boolean(),
    value: z.unknown(),
  })
  .passthrough();
export const ScoreRuleError = z
  .object({ name: z.string(), reason: z.string(), rule_id: z.string() })
  .passthrough();
export const ScoreContribution = z
  .object({ name: z.string(), points: z.number().int(), rule_id: z.string() })
  .passthrough();
export const LeadScoreDetail = z
  .object({
    band: z.union([z.null(), ScoreBandRef]).optional(),
    errors: z.array(ScoreRuleError),
    matched: z.array(ScoreContribution),
    summary: z.string(),
    total: z.number().int(),
    unavailable: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const LeadDetailResponse = LeadSummary.and(
  z
    .object({
      attempts: z.array(DistributionAttempt),
      custom_data: z.unknown(),
      distribution: DistributionSummary,
      properties: z.array(SubmissionProperty),
      raw_request: z.unknown().optional(),
      score_detail: z.union([z.null(), LeadScoreDetail]).optional(),
    })
    .passthrough()
);
export const ReturnLeadBody = z
  .object({
    buyer_ids: z.union([z.array(z.string()), z.null()]),
    note: z.union([z.string(), z.null()]),
    override_reason: z.union([z.string(), z.null()]),
    reason: z.union([z.string(), z.null()]),
    reason_code: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const LeadReturn = z
  .object({
    buyer_id: z.string(),
    buyer_name: z.string(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    created_at: z.string(),
    credit_amount: z.number(),
    decided_at: z.union([z.string(), z.null()]).optional(),
    decided_by_name: z.union([z.string(), z.null()]).optional(),
    decision_note: z.string(),
    id: z.string(),
    lead_fully_returned: z.boolean().optional(),
    lead_id: z.string(),
    note: z.string(),
    outside_window: z.boolean(),
    override_reason: z.string(),
    reason_code: z.string(),
    reason_label: z.string(),
    requested_by_name: z.string(),
    requested_via: z.string(),
    sale_amount: z.number(),
    sold_at: z.union([z.string(), z.null()]).optional(),
    source: z.string(),
    status: z.string(),
    supplier_id: z.string(),
    supplier_name: z.string(),
  })
  .passthrough();
export const ReturnLeadResponse = z
  .object({
    delivery_status: z.string(),
    lead_id: z.string(),
    returns: z.array(LeadReturn).optional(),
    revenue_reversed: z.boolean(),
  })
  .passthrough();
export const ReturnableSale = z
  .object({
    buyer_id: z.string(),
    buyer_name: z.string(),
    price: z.number(),
    return_id: z.union([z.string(), z.null()]).optional(),
    return_status: z.union([z.string(), z.null()]).optional(),
    returned: z.boolean(),
    sold_at: z.union([z.string(), z.null()]).optional(),
    window_closes_at: z.union([z.string(), z.null()]).optional(),
    window_days: z.number().int(),
    window_open: z.boolean(),
  })
  .passthrough();
export const LeadReturns = z
  .object({
    can_request: z.boolean(),
    can_return: z.boolean(),
    lead_id: z.string(),
    returns: z.array(LeadReturn),
    sales: z.array(ReturnableSale),
  })
  .passthrough();
export const FilterTab = z
  .object({
    filter_state: z.unknown().optional(),
    has_changes: z.boolean().optional(),
    id: z.number().int(),
    name: z.string(),
  })
  .passthrough();
export const FilterTabsResponse = z
  .object({
    active_tab_id: z.union([z.number(), z.null()]).optional(),
    next_tab_id: z.number().int(),
    tabs: z.array(FilterTab),
  })
  .passthrough();
export const Appearance = z.enum(["light", "dark", "system"]);
export const UserPreferences = z.object({ appearance: Appearance }).passthrough();
export const EnumValue = z
  .object({ label: z.string(), value: z.string() })
  .passthrough();
export const AlertEventType = z
  .object({
    description: z.string(),
    has_revenue_target: z.boolean(),
    has_threshold: z.boolean(),
    has_window: z.boolean(),
    label: z.string(),
    value: z.string(),
  })
  .passthrough();
export const RoleDefaults = z
  .object({
    actions: z.array(z.string()),
    nav_tabs: z.array(z.string()),
    role: z.string(),
  })
  .passthrough();
export const FilterOption = z
  .object({
    default: z.union([z.string(), z.null()]).optional(),
    free_text: z.boolean(),
    key: z.string(),
    label: z.string(),
    values: z.array(EnumValue),
  })
  .passthrough();
export const FilterType = z
  .object({
    label: z.string(),
    options: z.array(FilterOption),
    value: z.string(),
  })
  .passthrough();
export const EnumsResponse = z
  .object({
    acceptance_operators: z.array(EnumValue),
    account_statuses: z.array(z.string()),
    actions: z.array(z.string()),
    alert_event_types: z.array(AlertEventType),
    configurable_roles: z.array(z.string()),
    default_permissions: z.array(RoleDefaults),
    delivery_methods: z.array(EnumValue),
    delivery_statuses: z.array(EnumValue),
    distribution_methods: z.array(EnumValue),
    explore_dimensions: z.array(EnumValue),
    filter_types: z.array(FilterType),
    import_fields: z.array(EnumValue),
    lead_statuses: z.array(EnumValue),
    nav_tabs: z.array(z.string()),
    rejection_reasons: z.array(EnumValue),
    roles: z.array(z.string()),
    row_types: z.array(EnumValue),
  })
  .passthrough();
export const NotificationItem = z
  .object({
    body: z.string(),
    created_at: z.string(),
    event_type: z.string(),
    id: z.string(),
    read: z.boolean(),
    title: z.string(),
  })
  .passthrough();
export const NotificationListResponse = z
  .object({
    notifications: z.array(NotificationItem),
    unread: z.number().int(),
  })
  .passthrough();
export const AffectedResponse = z.object({ affected: z.number().int() }).passthrough();
export const PersonStream = z
  .object({ id: z.string(), name: z.string() })
  .passthrough();
export const PersonSummary = z
  .object({
    email: z.string(),
    first_seen: z.string(),
    id: z.string(),
    last_seen: z.string(),
    name: z.string(),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    phone: z.string(),
    properties: z.unknown(),
    score: z.union([z.number(), z.null()]).optional(),
    score_band: z.union([z.null(), ScoreBandRef]).optional(),
    sold: z.number().int(),
    streams: z.array(PersonStream),
    submissions: z.number().int(),
    total_value: z.number(),
  })
  .passthrough();
export const PeopleSource = z.enum(["email", "stored", "rollup"]);
export const PeopleListResponse = z
  .object({
    pagination: Pagination,
    people: z.array(PersonSummary),
    query_stats: z.union([z.null(), QueryStats]).optional(),
    source: PeopleSource,
  })
  .passthrough();
export const PeopleCountStream = z
  .object({
    campaign_id: z.string(),
    campaign_name: z.string(),
    people: z.number().int(),
    submissions: z.number().int(),
  })
  .passthrough();
export const PeopleCountPoint = z
  .object({
    date: z.string(),
    people: z.number().int(),
    submissions: z.number().int(),
  })
  .passthrough();
export const PeopleCountsResponse = z
  .object({
    people: z.number().int(),
    query_stats: z.union([z.null(), QueryStats]).optional(),
    source: PeopleSource,
    streams: z.array(PeopleCountStream),
    submissions: z.number().int(),
    total_value: z.number(),
    trend: z.array(PeopleCountPoint),
    updating: z.boolean(),
  })
  .passthrough();
export const PersonLinkView = z
  .object({
    created_at: z.string(),
    created_by: z.union([z.string(), z.null()]).optional(),
    created_by_name: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    kind: z.string(),
    other_person_id: z.union([z.string(), z.null()]).optional(),
    person_id: z.string(),
    rule: z.string(),
    submission_id: z.union([z.string(), z.null()]).optional(),
    undone_at: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const PersonLinkResponse = z
  .object({ link: PersonLinkView, person_id: z.string() })
  .passthrough();
export const PeopleSearchBody = z
  .object({
    filter: z.union([z.null(), LeadSearchBody]),
    max_score: z.union([z.number(), z.null()]),
    min_score: z.union([z.number(), z.null()]),
    min_submissions: z.union([z.number(), z.null()]),
    owner_user_id: z.union([z.string(), z.null()]),
    page: z.union([z.number(), z.null()]),
    page_size: z.union([z.number(), z.null()]),
    q: z.union([z.string(), z.null()]),
    score_band: z.union([z.string(), z.null()]),
    sort: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const PersonBase = z.enum(["max", "latest"]);
export const PersonScore = z
  .object({
    band: z.union([z.null(), ScoreBandRef]).optional(),
    base: z.number().int(),
    base_from: PersonBase,
    decay: z.number().int(),
    matched: z.array(ScoreContribution),
    points: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const PersonSubmission = z
  .object({
    buyer_name: z.string(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    created_at: z.string(),
    delivery_status: z.string(),
    email: z.string(),
    fullname: z.string(),
    id: z.string(),
    linked_by: z.string(),
    phone1: z.string(),
    revenue: z.number(),
    score: z.union([z.number(), z.null()]).optional(),
    sold: z.boolean(),
    status: z.string(),
    supplier_name: z.string(),
  })
  .passthrough();
export const PersonDetail = z
  .object({
    can_assign: z.boolean(),
    can_edit_properties: z.boolean(),
    can_link: z.boolean(),
    can_set_owner: z.boolean(),
    email: z.string(),
    emails: z.array(z.string()),
    first_seen: z.string(),
    id: z.string(),
    last_seen: z.string(),
    links: z.array(PersonLinkView),
    merged: z.array(z.string()),
    name: z.string(),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    phone: z.string(),
    phones: z.array(z.string()),
    properties: z.unknown(),
    score: z.union([z.null(), PersonScore]).optional(),
    sold: z.number().int(),
    source: PeopleSource,
    streams: z.array(PersonStream),
    submission_count: z.number().int(),
    submissions: z.array(PersonSubmission),
    suggestions: z.array(IdentitySuggestion),
    total_value: z.number(),
  })
  .passthrough();
export const UpdatePersonBody = z
  .object({ properties: z.unknown() })
  .partial()
  .passthrough();
export const PersonPropertiesView = z
  .object({
    id: z.string(),
    properties: z.unknown(),
    undefined_property_keys: z
      .union([z.array(z.string()), z.null()])
      .optional(),
  })
  .passthrough();
export const MergePeopleBody = z.object({ other_id: z.string() }).passthrough();
export const SetOwnerBody = z
  .object({ owner_user_id: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const OwnerView = z
  .object({
    id: z.string(),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const PipelineStage = z
  .object({
    archived: z.boolean(),
    id: z.string(),
    kind: StageKind,
    name: z.string(),
    pipeline_id: z.string(),
    position: z.number().int(),
    win_probability: z.number().int(),
  })
  .passthrough();
export const Pipeline = z
  .object({
    archived: z.boolean(),
    created_at: z.string(),
    id: z.string(),
    name: z.string(),
    position: z.number().int(),
    stages: z.array(PipelineStage),
    updated_at: z.string(),
  })
  .passthrough();
export const PipelineListResponse = z
  .object({ pipelines: z.array(Pipeline) })
  .passthrough();
export const CreateStageBody = z
  .object({
    kind: z.union([z.null(), StageKind]).optional(),
    name: z.string(),
    win_probability: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const CreatePipelineBody = z
  .object({
    name: z.string(),
    stages: z.union([z.array(CreateStageBody), z.null()]).optional(),
  })
  .passthrough();
export const UpdatePipelineBody = z
  .object({
    archived: z.union([z.boolean(), z.null()]),
    name: z.union([z.string(), z.null()]),
    position: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const ReorderStagesBody = z
  .object({ stage_ids: z.array(z.string()) })
  .passthrough();
export const UpdateStageBody = z
  .object({
    archived: z.union([z.boolean(), z.null()]),
    kind: z.union([z.null(), StageKind]),
    name: z.union([z.string(), z.null()]),
    win_probability: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const include_archived = z.union([z.boolean(), z.null()]).optional();
export const PropertyObject = z.enum(["person", "company", "deal", "submission"]);
export const PropertyOption = z
  .object({
    colour: z.union([z.string(), z.null()]).optional(),
    label: z.string().optional(),
    value: z.string(),
  })
  .passthrough();
export const PropertyDef = z
  .object({
    archived: z.boolean(),
    created_at: z.string(),
    created_by: z.string(),
    description: z.string(),
    group_name: z.string(),
    id: z.string(),
    key: z.string(),
    label: z.string(),
    object_type: PropertyObject,
    options: z.array(PropertyOption),
    position: z.number().int(),
    required: z.boolean(),
    type: PropertyType,
    updated_at: z.string(),
  })
  .passthrough();
export const PropertyListResponse = z
  .object({ can_manage: z.boolean(), properties: z.array(PropertyDef) })
  .passthrough();
export const CreatePropertyBody = z
  .object({
    description: z.union([z.string(), z.null()]).optional(),
    group_name: z.union([z.string(), z.null()]).optional(),
    key: z.string(),
    label: z.string(),
    object_type: PropertyObject,
    options: z.union([z.array(PropertyOption), z.null()]).optional(),
    required: z.union([z.boolean(), z.null()]).optional(),
    type: PropertyType,
  })
  .passthrough();
export const PropertyPositionsBody = z
  .object({ ids: z.array(z.string()), object_type: PropertyObject })
  .passthrough();
export const SeedPropertiesBody = z
  .object({ dry_run: z.union([z.boolean(), z.null()]) })
  .partial()
  .passthrough();
export const SeedSkipped = z
  .object({ key: z.string(), reason: z.string() })
  .passthrough();
export const SeedPropertiesResponse = z
  .object({
    created: z.array(PropertyDef),
    dry_run: z.boolean(),
    sampled: z.boolean(),
    skipped: z.array(SeedSkipped),
  })
  .passthrough();
export const UpdatePropertyBody = z
  .object({
    description: z.union([z.string(), z.null()]),
    group_name: z.union([z.string(), z.null()]),
    key: z.union([z.string(), z.null()]),
    label: z.union([z.string(), z.null()]),
    options: z.union([z.array(PropertyOption), z.null()]),
    required: z.union([z.boolean(), z.null()]),
    type: z.union([z.null(), PropertyType]),
  })
  .partial()
  .passthrough();
export const RecordType = z.enum(["submission", "person", "deal", "task"]);
export const WorkflowRunStatus = z.enum([
  "running",
  "waiting",
  "done",
  "failed",
  "cancelled",
  "goal_reached",
  "exited",
]);
export const TriggerKind = z.enum([
  "submission_arrived",
  "person_property_changed",
  "person_owner_changed",
  "deal_created",
  "deal_stage_changed",
  "deal_won",
  "deal_lost",
  "task_overdue",
  "score_band_changed",
  "email_event",
  "form_submitted",
  "email_link_clicked",
  "enrolment",
  "lead_returned",
]);
export const WorkflowRun = z
  .object({
    conditions_met: z.union([z.boolean(), z.null()]).optional(),
    current_step: z.number().int(),
    current_step_id: z.union([z.string(), z.null()]).optional(),
    enrolled: z.boolean(),
    error: z.union([z.string(), z.null()]).optional(),
    exit_detail: z.union([z.string(), z.null()]).optional(),
    finished_at: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    last_wait: z.union([z.string(), z.null()]).optional(),
    next_at: z.union([z.string(), z.null()]).optional(),
    record_id: z.string(),
    record_type: RecordType,
    started_at: z.string(),
    status: WorkflowRunStatus,
    step_count: z.number().int(),
    trigger_kind: TriggerKind,
    workflow_id: z.string(),
    workflow_name: z.string(),
    workflow_version: z.number().int(),
  })
  .passthrough();
export const RecordWorkflowRunsResponse = z
  .object({ runs: z.array(WorkflowRun) })
  .passthrough();
export const BuyerPerformanceRow = z
  .object({
    buyer_name: z.string(),
    delivered: z.number().int(),
    failed: z.number().int(),
    payout: z.number(),
    price: z.number(),
    success_rate: z.number(),
    total_leads: z.number().int(),
    total_revenue: z.number(),
  })
  .passthrough();
export const StatusCount = z
  .object({ count: z.number().int(), status: z.string() })
  .passthrough();
export const CampaignPerformanceRow = z
  .object({
    avg_revenue: z.number(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    delivery_rate: z.number(),
    funnel: z.array(StatusCount),
    margin: z.union([z.number(), z.null()]).optional(),
    margin_pct: z.union([z.number(), z.null()]).optional(),
    total_leads: z.number().int(),
    total_payout: z.number(),
    total_revenue: z.number(),
  })
  .passthrough();
export const ReportMetrics = z
  .object({
    avg_revenue: z.number(),
    delivery_rate: z.number(),
    margin: z.union([z.number(), z.null()]).optional(),
    margin_pct: z.union([z.number(), z.null()]).optional(),
    total_leads: z.number().int(),
    total_payout: z.number(),
    total_revenue: z.number(),
  })
  .passthrough();
export const ReportsResponse = z
  .object({
    buyers: z.array(BuyerPerformanceRow),
    campaigns: z.array(CampaignPerformanceRow),
    lead_trend: z.array(TimeSeriesPoint),
    metrics: ReportMetrics,
    money: MoneyVisibility,
    query_stats: z.union([z.null(), QueryStats]).optional(),
    status_breakdown: z.array(NamedCount),
  })
  .passthrough();
export const EntityStat = z
  .object({
    delivered: z.number().int(),
    failed: z.number().int(),
    margin: z.union([z.number(), z.null()]).optional(),
    margin_pct: z.union([z.number(), z.null()]).optional(),
    name: z.string(),
    rate: z.number(),
    total_leads: z.number().int(),
    total_payout: z.number(),
    total_revenue: z.number(),
  })
  .passthrough();
export const EntityStatsResponse = z
  .object({
    buyers: z.array(EntityStat),
    campaigns: z.array(EntityStat),
    destinations: z.array(EntityStat),
    money: MoneyVisibility,
    suppliers: z.array(EntityStat),
  })
  .passthrough();
export const ExploreRequest = z
  .object({
    campaign_id: z.union([z.string(), z.null()]).optional(),
    date_from: z.union([z.string(), z.null()]).optional(),
    date_range: z.union([z.string(), z.null()]).optional(),
    date_to: z.union([z.string(), z.null()]).optional(),
    group_by: z.array(z.string()),
  })
  .passthrough();
export const ExploreRow = z
  .object({
    conversion_rate: z.number(),
    key: z.string(),
    key2: z.union([z.string(), z.null()]).optional(),
    label: z.string(),
    label2: z.union([z.string(), z.null()]).optional(),
    leads: z.number().int(),
    margin_pct: z.union([z.number(), z.null()]).optional(),
    payout: z.number(),
    profit: z.number(),
    revenue: z.number(),
    sold: z.number().int(),
  })
  .passthrough();
export const ExploreTotals = z
  .object({
    conversion_rate: z.number(),
    leads: z.number().int(),
    margin_pct: z.union([z.number(), z.null()]).optional(),
    payout: z.number(),
    profit: z.number(),
    revenue: z.number(),
    sold: z.number().int(),
  })
  .passthrough();
export const ExploreResponse = z
  .object({
    group_by: z.array(z.string()),
    is_pivot: z.boolean(),
    money: MoneyVisibility,
    query_stats: z.union([z.null(), QueryStats]).optional(),
    rows: z.array(ExploreRow),
    totals: ExploreTotals,
  })
  .passthrough();
export const ReturnsReportRow = z
  .object({
    credits: z.number(),
    key: z.string(),
    label: z.string(),
    requested: z.number().int(),
    return_rate: z.union([z.number(), z.null()]).optional(),
    returned: z.number().int(),
    sales: z.number().int(),
  })
  .passthrough();
export const ReturnsReport = z
  .object({
    from: z.string(),
    group_by: z.string(),
    rows: z.array(ReturnsReportRow),
    to: z.string(),
    total: ReturnsReportRow,
  })
  .passthrough();
export const ReportView = z
  .object({
    config: z.unknown(),
    created_at: z.string(),
    id: z.string(),
    name: z.string(),
  })
  .passthrough();
export const ReportViewListResponse = z
  .object({ views: z.array(ReportView) })
  .passthrough();
export const CreateReportView = z
  .object({ config: z.unknown(), name: z.string() })
  .passthrough();
export const ReturnCounts = z
  .object({
    approved: z.number().int(),
    rejected: z.number().int(),
    requested: z.number().int(),
  })
  .passthrough();
export const ReturnsList = z
  .object({
    counts: ReturnCounts,
    returns: z.array(LeadReturn),
    total: z.number().int(),
  })
  .passthrough();
export const CreateReturnsBody = z
  .object({
    buyer_ids: z.union([z.array(z.string()), z.null()]).optional(),
    lead_ids: z.array(z.string()),
    note: z.union([z.string(), z.null()]).optional(),
    override_reason: z.union([z.string(), z.null()]).optional(),
    reason_code: z.string(),
  })
  .passthrough();
export const ReturnFailure = z
  .object({ error: z.string(), id: z.string() })
  .passthrough();
export const ReturnsResult = z
  .object({ failed: z.array(ReturnFailure), returns: z.array(LeadReturn) })
  .passthrough();
export const ReturnDecision = z.enum(["approve", "reject"]);
export const DecideReturnsBody = z
  .object({
    decision: ReturnDecision,
    ids: z.array(z.string()),
    note: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const RequestReturnBody = z
  .object({
    lead_id: z.string(),
    note: z.union([z.string(), z.null()]).optional(),
    reason_code: z.string(),
  })
  .passthrough();
export const RouteOverview = z
  .object({
    buyer_id: z.string(),
    buyer_name: z.string(),
    campaign_active: z.boolean(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    company_id: z.union([z.string(), z.null()]).optional(),
    days: ActiveDaysResolution,
    delivery_method: z.string(),
    destination_active: z.boolean(),
    destination_id: z.string(),
    destination_name: z.string(),
    effective_caps: Caps,
    group_active: z.boolean(),
    group_id: z.string(),
    group_name: z.string(),
    group_priority: z.number().int(),
    kind: z.string(),
    link_active: z.boolean(),
    link_id: z.string(),
    live: z.boolean(),
    price: PriceResolution,
    team_id: z.union([z.string(), z.null()]).optional(),
    user_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const UnlinkedDestination = z
  .object({
    buyer_name: z.string(),
    id: z.string(),
    kind: z.string(),
    name: z.string(),
  })
  .passthrough();
export const RoutesOverviewResponse = z
  .object({
    routes: z.array(RouteOverview),
    unlinked: z.array(UnlinkedDestination),
  })
  .passthrough();
export const DraftScoringRule = z
  .object({
    active: z.union([z.boolean(), z.null()]).optional(),
    campaign_ids: z.union([z.array(z.string()), z.null()]).optional(),
    conditions: z.unknown(),
    id: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    points: z.number().int(),
  })
  .passthrough();
export const ScorePreviewBody = z
  .object({
    campaign_id: z.union([z.string(), z.null()]),
    draft: z.union([z.null(), DraftScoringRule]),
    rules: z.union([z.array(DraftScoringRule), z.null()]),
    sample: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const ScoreBandCount = z
  .object({
    colour: z.string(),
    count: z.number().int(),
    key: z.string(),
    label: z.string(),
  })
  .passthrough();
export const ScorePreviewExample = z
  .object({
    band: z.union([z.null(), ScoreBandRef]).optional(),
    campaign_name: z.string(),
    created_at: z.string(),
    email: z.string(),
    lead_id: z.string(),
    matched: z.array(ScoreContribution),
    name: z.string(),
    score: z.number().int(),
  })
  .passthrough();
export const ScoreBucket = z
  .object({
    count: z.number().int(),
    from: z.number().int(),
    to: z.number().int(),
  })
  .passthrough();
export const ScoreRuleHits = z
  .object({
    errored: z.number().int(),
    matched: z.number().int(),
    name: z.string(),
    points: z.number().int(),
    rule_id: z.string(),
  })
  .passthrough();
export const ScorePreviewResponse = z
  .object({
    average: z.number(),
    bands: z.array(ScoreBandCount),
    bottom: z.array(ScorePreviewExample),
    errors: z.array(ScoreRuleError),
    histogram: z.array(ScoreBucket),
    max: z.number().int(),
    median: z.number().int(),
    min: z.number().int(),
    rules: z.array(ScoreRuleHits),
    sampled: z.number().int(),
    top: z.array(ScorePreviewExample),
  })
  .passthrough();
export const ScoreFact = z
  .object({ key: z.string(), label: z.string() })
  .passthrough();
export const ScoreObject = z.enum(["submission", "person"]);
export const ScoringRule = z
  .object({
    active: z.boolean(),
    campaign_ids: z.array(z.string()),
    conditions: z.unknown(),
    created_at: z.string(),
    created_by: z.string(),
    id: z.string(),
    name: z.string(),
    object: ScoreObject,
    points: z.number().int(),
    position: z.number().int(),
    updated_at: z.string(),
  })
  .passthrough();
export const ScoringRuleListResponse = z
  .object({
    can_manage: z.boolean(),
    person_facts: z.array(ScoreFact),
    person_types: z.array(z.string()),
    rules: z.array(ScoringRule),
    submission_types: z.array(z.string()),
  })
  .passthrough();
export const CreateScoringRuleBody = z
  .object({
    active: z.union([z.boolean(), z.null()]).optional(),
    campaign_ids: z.union([z.array(z.string()), z.null()]).optional(),
    conditions: z.unknown(),
    name: z.string(),
    object: ScoreObject,
    points: z.number().int(),
  })
  .passthrough();
export const ReorderScoringRulesBody = z
  .object({ ids: z.array(z.string()), object: ScoreObject })
  .passthrough();
export const UpdateScoringRuleBody = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    campaign_ids: z.union([z.array(z.string()), z.null()]),
    conditions: z.unknown(),
    name: z.union([z.string(), z.null()]),
    points: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const ActivateScoringRuleBody = z.object({ active: z.boolean() }).passthrough();
export const SegmentPerson = z
  .object({
    id: z.string(),
    is_you: z.boolean(),
    name: z.string(),
    role: z.string(),
  })
  .passthrough();
export const SegmentPeople = z
  .object({ people: z.array(SegmentPerson) })
  .passthrough();
export const SegmentVisibility = z.enum(["everyone", "people"]);
export const SharedSegment = z
  .object({
    can_edit: z.boolean(),
    created_at: z.string(),
    filter_state: z.unknown().optional(),
    id: z.string(),
    is_owner: z.boolean(),
    name: z.string(),
    owner_name: z.string(),
    owner_user_id: z.string(),
    shared_with: z.array(z.string()),
    updated_at: z.string(),
    updated_by: z.string(),
    visibility: SegmentVisibility,
  })
  .passthrough();
export const SharedSegmentList = z
  .object({ can_share: z.boolean(), segments: z.array(SharedSegment) })
  .passthrough();
export const CreateSharedSegmentBody = z
  .object({
    filter_state: z.unknown().optional(),
    from_tab_id: z.union([z.number(), z.null()]).optional(),
    name: z.string(),
    shared_with: z.union([z.array(z.string()), z.null()]).optional(),
    visibility: SegmentVisibility,
  })
  .passthrough();
export const UpdateSharedSegmentBody = z
  .object({
    filter_state: z.unknown(),
    name: z.union([z.string(), z.null()]),
    shared_with: z.union([z.array(z.string()), z.null()]),
    visibility: z.union([z.null(), SegmentVisibility]),
  })
  .partial()
  .passthrough();
export const SegmentMadePrivate = z
  .object({ owner_user_id: z.string(), tab_id: z.number().int() })
  .passthrough();
export const AiSettingsView = z
  .object({
    assistant_enabled: z.boolean(),
    banned_terms: z.array(z.string()),
    built_in_banned: z.number().int().gte(0),
    default_model: z.string(),
    key_set: z.boolean(),
    model: z.string(),
  })
  .passthrough();
export const AiSettingsBody = z
  .object({
    api_key: z.string(),
    assistant_enabled: z.union([z.boolean(), z.null()]),
    banned_terms: z.union([z.array(z.string()), z.null()]),
    model: z.string(),
    remove_key: z.boolean(),
  })
  .partial()
  .passthrough();
export const ApnsSettingsView = z
  .object({
    bundle_id: z.string(),
    configured: z.boolean(),
    has_p8_key: z.boolean(),
    key_id: z.string(),
    p8_key: z.string(),
    team_id: z.string(),
  })
  .passthrough();
export const ApnsSettings = z
  .object({
    bundle_id: z.string(),
    key_id: z.string(),
    p8_key: z.string(),
    team_id: z.string(),
  })
  .partial()
  .passthrough();
export const BillingSettings = z
  .object({
    address: z.string(),
    bank_details: z.string(),
    company_number: z.string(),
    legal_name: z.string(),
    payment_terms_days: z.number().int(),
    statement_prefix: z.string(),
    supplier_statement_prefix: z.string(),
    vat_number: z.string(),
    vat_rate_pct: z.number(),
    vat_registered: z.boolean(),
  })
  .partial()
  .passthrough();
export const CrmAccessSettings = z
  .object({ sales_see_unowned: z.boolean() })
  .partial()
  .passthrough();
export const BrandSunset = z
  .object({
    brand_id: z.string(),
    enabled: z.boolean().optional(),
    max_days: z.number().int().optional(),
    min_sends: z.number().int().optional(),
  })
  .passthrough();
export const SunsetSettings = z
  .object({
    brands: z.array(BrandSunset),
    enabled: z.boolean(),
    max_days: z.number().int(),
    min_sends: z.number().int(),
    signal: z.string(),
  })
  .partial()
  .passthrough();
export const ElvSettingsView = z
  .object({
    cache_days: z.number().int(),
    configured: z.boolean(),
    enabled: z.boolean(),
    has_key: z.boolean(),
    inconclusive_policy: z.string(),
    key_last4: z.string(),
    send_ok_for_all: z.boolean(),
    verify_on_arrival: z.boolean(),
  })
  .passthrough();
export const ElvSettingsBody = z
  .object({
    api_key: z.union([z.string(), z.null()]),
    cache_days: z.union([z.number(), z.null()]),
    clear_key: z.boolean(),
    enabled: z.union([z.boolean(), z.null()]),
    inconclusive_policy: z.union([z.string(), z.null()]),
    send_ok_for_all: z.union([z.boolean(), z.null()]),
    verify_on_arrival: z.union([z.boolean(), z.null()]),
  })
  .partial()
  .passthrough();
export const ElvTestBody = z
  .object({ api_key: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const ElvTestResponse = z
  .object({
    credits: z.union([z.null(), ElvCreditsView]).optional(),
    error: z.string(),
    ok: z.boolean(),
  })
  .passthrough();
export const FeatureSettings = z
  .object({ crm: z.boolean(), distribution: z.boolean() })
  .partial()
  .passthrough();
export const HlrSettingsView = z
  .object({
    api_key: z.string(),
    api_key_last4: z.string(),
    api_secret: z.string(),
    configured: z.boolean(),
    has_api_key: z.boolean(),
    has_api_secret: z.boolean(),
    test_mode: z.boolean(),
  })
  .passthrough();
export const HlrSettings = z
  .object({
    api_key: z.string(),
    api_secret: z.string(),
    test_mode: z.boolean(),
  })
  .partial()
  .passthrough();
export const PeopleLayerStatus = z
  .object({
    backfilled_at: z.union([z.string(), z.null()]).optional(),
    dictionaries: z.boolean(),
    linking_live: z.boolean(),
    open_suggestions: z.number().int(),
    rollups: z.boolean(),
    stored: z.boolean(),
  })
  .passthrough();
export const IdentitySettings = z
  .object({
    is_default: z.boolean(),
    layer: PeopleLayerStatus,
    lookback_days: z.number().int(),
    mode: z.string(),
    phone_mode: z.string(),
  })
  .passthrough();
export const IdentitySettingsBody = z
  .object({
    lookback_days: z.number().int().optional(),
    mode: z.string(),
    phone_mode: z.string(),
  })
  .passthrough();
export const ReturnReason = z
  .object({
    active: z.boolean().optional(),
    code: z.string(),
    label: z.string(),
  })
  .passthrough();
export const ReturnsSettings = z
  .object({
    auto_approve_buyer_requests: z.boolean(),
    default_window_days: z.number().int(),
    reasons: z.array(ReturnReason),
  })
  .partial()
  .passthrough();
export const ScoreBand = z
  .object({
    colour: z.string(),
    key: z.string(),
    label: z.string(),
    min: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const ScoreDecay = z
  .object({ every_days: z.number().int(), points: z.number().int() })
  .passthrough();
export const ScoringSettings = z
  .object({
    bands: z.array(ScoreBand),
    decay: ScoreDecay.optional(),
    person_base: PersonBase.optional(),
  })
  .passthrough();
export const SesSettingsView = z
  .object({
    access_key_id: z.string(),
    company_address: z.string(),
    company_name: z.string(),
    configuration_set: z.string(),
    configured: z.boolean(),
    region: z.string(),
    secret_set: z.boolean(),
  })
  .passthrough();
export const SesSettingsBody = z
  .object({
    access_key_id: z.string(),
    company_address: z.string(),
    company_name: z.string(),
    configuration_set: z.string(),
    region: z.string(),
    secret_access_key: z.string(),
  })
  .partial()
  .passthrough();
export const SesHookResponse = z.object({ url: z.string() }).passthrough();
export const VocabularyPreset = z.enum(["general", "lead_distribution"]);
export const VocabularySettingsView = z
  .object({ chosen: z.boolean(), preset: VocabularyPreset })
  .passthrough();
export const VocabularySettings = z.object({ preset: VocabularyPreset }).passthrough();
export const SheetCampaign = z
  .object({ campaign_id: z.string(), campaign_name: z.string() })
  .passthrough();
export const Sheet = z
  .object({
    columns: z.array(z.string()),
    created_at: z.string(),
    created_by: z.string().optional(),
    description: z.string().optional(),
    editable: z.boolean().optional(),
    error_message: z.union([z.string(), z.null()]).optional(),
    file_name: z.string(),
    id: z.string(),
    import_job_id: z.union([z.string(), z.null()]).optional(),
    imported_into: z.array(SheetCampaign).optional(),
    parent_name: z.union([z.string(), z.null()]).optional(),
    parent_sheet_id: z.union([z.string(), z.null()]).optional(),
    row_count: z.number().int(),
    status: z.string(),
    supplier_id: z.union([z.string(), z.null()]).optional(),
    supplier_name: z.union([z.string(), z.null()]).optional(),
    version: z.number().int().optional(),
  })
  .passthrough();
export const SheetListResponse = z.object({ sheets: z.array(Sheet) }).passthrough();
export const CreateSheetBody = z
  .object({
    file_key: z.union([z.string(), z.null()]),
    file_name: z.union([z.string(), z.null()]),
    import_job_id: z.union([z.string(), z.null()]),
    supplier_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const UpdateSheetBody = z
  .object({
    description: z.union([z.string(), z.null()]),
    file_name: z.union([z.string(), z.null()]),
    supplier_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ReorderColumnsBody = z
  .object({ columns: z.array(z.string()) })
  .passthrough();
export const AddColumnBody = z.object({ name: z.string() }).passthrough();
export const DropColumnBody = z.object({ name: z.string() }).passthrough();
export const RenameColumnBody = z
  .object({ from: z.string(), to: z.string() })
  .passthrough();
export const CommitSheetBody = z
  .object({
    description: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ComputedColumnBody = z
  .object({
    amount: z.union([z.string(), z.null()]).optional(),
    find: z.union([z.string(), z.null()]).optional(),
    kind: z.string(),
    name: z.string(),
    sources: z.array(z.string()),
  })
  .passthrough();
export const SheetCountCell = z
  .object({ col: z.string(), value: z.string() })
  .passthrough();
export const SheetCountBody = z
  .object({ cells: z.array(SheetCountCell) })
  .passthrough();
export const SheetCountResult = z
  .object({ col: z.string(), rows: z.number().int(), value: z.string() })
  .passthrough();
export const SheetCounts = z
  .object({
    combined: z.number().int(),
    counts: z.array(SheetCountResult),
    total: z.number().int(),
  })
  .passthrough();
export const DedupeBody = z
  .object({
    cols: z.array(z.string()),
    description: z.union([z.string(), z.null()]).optional(),
    keep_last: z.boolean().optional(),
    name: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SheetFilterSpec = z
  .object({
    col: z.string(),
    op: z.string(),
    value: z.union([z.string(), z.null()]).optional(),
    value2: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const DeleteRowsBody = z
  .object({
    description: z.union([z.string(), z.null()]).optional(),
    filters: z.array(SheetFilterSpec),
    keep_matching: z.boolean().optional(),
    name: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SheetDuplicate = z
  .object({ rows: z.number().int(), value: z.string() })
  .passthrough();
export const SheetDuplicates = z
  .object({
    col: z.string(),
    repeated_rows: z.number().int(),
    values: z.array(SheetDuplicate),
  })
  .passthrough();
export const SheetEdit = z
  .object({
    col: z.string(),
    row_no: z.number().int(),
    val: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SheetEditsBody = z.object({ edits: z.array(SheetEdit) }).passthrough();
export const SheetEditSummary = z
  .object({ edited_cells: z.number().int() })
  .passthrough();
export const FormulaColumnBody = z
  .object({ formula: z.string(), name: z.string() })
  .passthrough();
export const FormulaCheck = z
  .object({
    error: z.string(),
    ok: z.boolean(),
    sample: z.array(z.string()),
    sources: z.array(z.string()),
  })
  .passthrough();
export const SheetHistoryCheck = z
  .object({
    created_at: z.string(),
    error_message: z.union([z.string(), z.null()]).optional(),
    job_id: z.string(),
    rows_invalid: z.union([z.number(), z.null()]).optional(),
    rows_processed: z.union([z.number(), z.null()]).optional(),
    rows_verified: z.union([z.number(), z.null()]).optional(),
    sheet_version: z.union([z.number(), z.null()]).optional(),
    status: z.string(),
  })
  .passthrough();
export const SheetHistoryImport = z
  .object({
    campaign_name: z.string(),
    created_at: z.string(),
    error_message: z.union([z.string(), z.null()]).optional(),
    job_id: z.string(),
    rows_imported: z.union([z.number(), z.null()]).optional(),
    rows_invalid: z.union([z.number(), z.null()]).optional(),
    sheet_version: z.union([z.number(), z.null()]).optional(),
    status: z.string(),
  })
  .passthrough();
export const SheetVersion = z
  .object({
    action: z.string(),
    created_at: z.string(),
    created_by: z.string(),
    is_current: z.boolean(),
    parent_version: z.union([z.number(), z.null()]).optional(),
    row_count: z.union([z.number(), z.null()]).optional(),
    version: z.number().int(),
  })
  .passthrough();
export const SheetHistory = z
  .object({
    checks: z.array(SheetHistoryCheck),
    imports: z.array(SheetHistoryImport),
    versions: z.array(SheetVersion),
  })
  .passthrough();
export const SheetImportBody = z
  .object({
    campaign_id: z.string(),
    column_mapping: z.record(z.string()),
    distribute: z.boolean().optional(),
    filters: z.array(SheetFilterSpec).optional(),
    row_limit: z.union([z.number(), z.null()]).optional(),
    supplier_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SheetJobStarted = z.object({ job_id: z.string() }).passthrough();
export const MatchLeadsBody = z
  .object({
    address_col: z.union([z.string(), z.null()]).optional(),
    col: z.string(),
  })
  .passthrough();
export const MatchLeadsResponse = z
  .object({
    different_property: z.number().int(),
    matched_leads: z.number().int(),
    matched_postcodes: z.number().int(),
    no_house_number: z.number().int(),
    sheet_id: z.string(),
    source_postcode_shaped: z.number().int(),
    source_postcodes: z.number().int(),
    with_email_consent: z.number().int(),
    with_sms_consent: z.number().int(),
  })
  .passthrough();
export const SheetPage = z
  .object({
    columns: z.array(z.string()),
    edited: z.array(z.array(z.any())),
    edited_cells: z.number().int(),
    is_current: z.boolean(),
    limit: z.number().int(),
    matching_rows: z.number().int(),
    offset: z.number().int(),
    row_count: z.number().int(),
    row_numbers: z.array(z.number().int()),
    rows: z.array(z.array(z.string())),
    version: z.number().int(),
  })
  .passthrough();
export const SheetColumnStats = z
  .object({
    col: z.string(),
    empty: z.number().int(),
    max: z.union([z.number(), z.null()]).optional(),
    min: z.union([z.number(), z.null()]).optional(),
    numeric: z.number().int(),
    sum: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const SheetStats = z
  .object({ columns: z.array(SheetColumnStats), rows: z.number().int() })
  .passthrough();
export const SheetSummaryValue = z
  .object({ rows: z.number().int(), value: z.string() })
  .passthrough();
export const SheetSummary = z
  .object({
    col: z.string(),
    distinct_listed: z.number().int(),
    rows_covered: z.number().int(),
    values: z.array(SheetSummaryValue),
  })
  .passthrough();
export const SuppressBody = z
  .object({
    address_col: z.union([z.string(), z.null()]).optional(),
    against_address_col: z.union([z.string(), z.null()]).optional(),
    against_col: z.string(),
    against_sheet_id: z.string(),
    col: z.string(),
    description: z.union([z.string(), z.null()]).optional(),
    keep: z.union([z.string(), z.null()]).optional(),
    name: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SheetTransform = z
  .object({
    col: z.string(),
    find: z.string(),
    id: z.string(),
    kind: z.string(),
    replace: z.string(),
    sources: z.array(z.string()).optional(),
  })
  .passthrough();
export const SheetTransformList = z
  .object({ transforms: z.array(SheetTransform) })
  .passthrough();
export const SheetTransformBody = z
  .object({
    col: z.string(),
    find: z.union([z.string(), z.null()]).optional(),
    kind: z.string(),
    replace: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SheetVerifyBody = z.object({ column: z.string() }).passthrough();
export const StatementKind = z.enum(["buyer", "supplier"]);
export const Totals = z
  .object({
    deductions_count: z.number().int(),
    deductions_pence: z.number().int(),
    gross_count: z.number().int(),
    gross_pence: z.number().int(),
    net_pence: z.number().int(),
    total_pence: z.number().int(),
    vat_pence: z.number().int(),
    vat_rate_bp: z.number().int(),
  })
  .passthrough();
export const StatementSummary = z
  .object({
    due_date: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.string(), z.null()]).optional(),
    issue_date: z.union([z.string(), z.null()]).optional(),
    kind: StatementKind,
    number: z.union([z.string(), z.null()]).optional(),
    paid_at: z.union([z.string(), z.null()]).optional(),
    party_id: z.string(),
    party_name: z.string(),
    period: z.string(),
    status: z.string(),
    totals: Totals,
  })
  .passthrough();
export const StatementList = z
  .object({ statements: z.array(StatementSummary) })
  .passthrough();
export const LineKind = z.enum(["sale", "credit", "charge", "chargeback"]);
export const SummaryLine = z
  .object({
    amount_pence: z.number().int(),
    campaign_id: z.string(),
    campaign_name: z.string(),
    count: z.number().int(),
    day: z.string(),
    kind: LineKind,
  })
  .passthrough();
export const PartyDetails = z
  .object({
    address: z.string(),
    bank_details: z.string(),
    email: z.string(),
    name: z.string(),
    reference: z.string(),
    vat_number: z.string(),
    vat_rate_pct: z.union([z.number(), z.null()]),
    vat_registered: z.boolean(),
  })
  .partial()
  .passthrough();
export const Statement = z
  .object({
    can_finalise: z.boolean(),
    currency: z.string(),
    due_date: z.string(),
    finalise_blocked: z.union([z.string(), z.null()]).optional(),
    finalised_at: z.union([z.string(), z.null()]).optional(),
    finalised_by_name: z.union([z.string(), z.null()]).optional(),
    from: BillingSettings,
    id: z.union([z.string(), z.null()]).optional(),
    issue_date: z.string(),
    kind: StatementKind,
    lines: z.array(SummaryLine),
    number: z.union([z.string(), z.null()]).optional(),
    paid_at: z.union([z.string(), z.null()]).optional(),
    party_id: z.string(),
    party_name: z.string(),
    period: z.string(),
    period_end: z.string(),
    period_label: z.string(),
    period_start: z.string(),
    status: z.string(),
    to: PartyDetails,
    totals: Totals,
  })
  .passthrough();
export const FinaliseBody = z
  .object({ kind: StatementKind, party_id: z.string(), period: z.string() })
  .passthrough();
export const MarkPaidBody = z
  .object({ paid_on: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const TaskCounts = z
  .object({
    open: z.number().int(),
    overdue: z.number().int(),
    today: z.number().int(),
    week: z.number().int(),
  })
  .passthrough();
export const TaskListResponse = z
  .object({
    counts: TaskCounts,
    pagination: Pagination,
    tasks: z.array(Activity),
  })
  .passthrough();
export const TemplateSummary = z
  .object({
    applied: z.boolean(),
    applied_campaign_id: z.union([z.string(), z.null()]).optional(),
    creates: z.array(z.string()),
    description: z.string(),
    key: z.string(),
    name: z.string(),
    next_step: z.union([z.string(), z.null()]).optional(),
    version: z.number().int(),
  })
  .passthrough();
export const TemplateListResponse = z
  .object({
    has_streams: z.boolean(),
    templates: z.array(TemplateSummary),
    wording_chosen: z.boolean(),
  })
  .passthrough();
export const ApplyTemplateBody = z
  .object({ onboarding: z.boolean() })
  .partial()
  .passthrough();
export const ApplyTemplateResponse = z
  .object({
    applied: z.boolean(),
    campaign_id: z.union([z.string(), z.null()]).optional(),
    created: z.array(z.string()),
    key: z.string(),
    next_step: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const TemplatePreview = z
  .object({
    adds: z.array(z.string()),
    already_applied: z.boolean(),
    keeps: z.array(z.string()),
    key: z.string(),
    name: z.string(),
    next_step: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const TimelineItemKind = z.enum([
  "note",
  "task",
  "call",
  "meeting",
  "arrived",
  "routed",
  "redistributed",
  "returned",
  "email",
  "source_arrived",
  "deal_created",
  "stage_changed",
  "deal_won",
  "deal_lost",
  "linked",
  "merged",
  "unlinked",
  "owner_changed",
  "assigned",
  "workflow",
]);
export const TimelineLinkType = z.enum([
  "deal",
  "company",
  "submission",
  "partner_leads",
  "source_leads",
  "person",
]);
export const TimelineLink = z
  .object({
    label: z.union([z.string(), z.null()]).optional(),
    object_id: z.string(),
    object_type: TimelineLinkType,
  })
  .passthrough();
export const TimelineItem = z
  .object({
    activity: z.union([z.null(), Activity]).optional(),
    at: z.string(),
    by_name: z.union([z.string(), z.null()]).optional(),
    by_user_id: z.union([z.string(), z.null()]).optional(),
    detail: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    kind: TimelineItemKind,
    link: z.union([z.null(), TimelineLink]).optional(),
    text: z.string(),
    undo_link_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const TimelineSummary = z
  .object({ link: TimelineLink, text: z.string() })
  .passthrough();
export const TimelineResponse = z
  .object({
    items: z.array(TimelineItem),
    next_cursor: z.union([z.string(), z.null()]).optional(),
    notes: z.array(z.string()),
    object_id: z.string(),
    object_type: ActivityObjectType,
    summaries: z.array(TimelineSummary),
  })
  .passthrough();
export const VerifyJob = z
  .object({
    completed_at: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    error_message: z.union([z.string(), z.null()]).optional(),
    file_name: z.string(),
    job_id: z.string(),
    rows_invalid: z.number().int(),
    rows_processed: z.number().int(),
    rows_total: z.number().int(),
    rows_verified: z.number().int(),
    status: z.string(),
  })
  .passthrough();
export const VerifyJobListResponse = z
  .object({ jobs: z.array(VerifyJob), pagination: Pagination })
  .passthrough();
export const WorkflowFolder = z
  .object({ count: z.number().int(), id: z.string(), name: z.string() })
  .passthrough();
export const WorkflowFoldersResponse = z
  .object({
    folders: z.array(WorkflowFolder),
    suggestions: z.array(z.string()),
  })
  .passthrough();
export const WorkflowFolderBody = z.object({ name: z.string() }).passthrough();
export const WorkflowField = z
  .object({ key: z.string(), label: z.string() })
  .passthrough();
export const WorkflowRecordFields = z
  .object({ fields: z.array(WorkflowField), record_type: RecordType })
  .passthrough();
export const StepKind = z.enum([
  "set_property",
  "assign_owner",
  "create_task",
  "send_email",
  "send_sms",
  "notify",
  "move_stage",
  "webhook",
  "wait",
  "wait_until",
  "branch",
  "end",
  "go_to",
  "repeat",
]);
const WorkflowStep: z.ZodType<WorkflowStep> = z.lazy(() =>
  z
    .object({
      body: z.array(WorkflowStep).optional(),
      config: z.unknown(),
      id: z.string(),
      kind: StepKind,
      no: z.array(WorkflowStep).optional(),
      yes: z.array(WorkflowStep).optional(),
    })
    .passthrough()
);
export const EmailEventKind = z.enum(["open", "click", "bounce", "unsubscribe"]);
export const WorkflowTrigger = z
  .object({
    band: z.union([z.string(), z.null()]).optional(),
    campaign_ids: z.union([z.array(z.string()), z.null()]).optional(),
    email_campaign_id: z.union([z.string(), z.null()]).optional(),
    email_events: z.union([z.array(EmailEventKind), z.null()]).optional(),
    email_template_id: z.union([z.string(), z.null()]).optional(),
    form_id: z.union([z.string(), z.null()]).optional(),
    from_stage_id: z.union([z.string(), z.null()]).optional(),
    kind: TriggerKind,
    link_name: z.union([z.string(), z.null()]).optional(),
    pipeline_id: z.union([z.string(), z.null()]).optional(),
    property_key: z.union([z.string(), z.null()]).optional(),
    record_type: z.union([z.null(), RecordType]).optional(),
    to_stage_id: z.union([z.string(), z.null()]).optional(),
    url_contains: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WorkflowTemplate = z
  .object({
    conditions: z.unknown(),
    description: z.string(),
    key: z.string(),
    name: z.string(),
    needs: z.array(z.string()),
    steps: z.array(WorkflowStep),
    trigger: WorkflowTrigger,
  })
  .passthrough();
export const WorkflowHealthState = z.enum([
  "archived",
  "off",
  "erroring",
  "never_runs",
  "waiting",
  "ok",
]);
export const WorkflowHealth = z
  .object({
    failures_24h: z.number().int(),
    last_error: z.union([z.string(), z.null()]).optional(),
    last_run_at: z.union([z.string(), z.null()]).optional(),
    state: WorkflowHealthState,
    waiting: z.number().int(),
  })
  .passthrough();
export const WorkflowOverlap = z
  .object({ id: z.string(), kind: z.string(), name: z.string() })
  .passthrough();
export const WorkflowSendOnce = z
  .object({
    at: z.string(),
    done: z.number().int(),
    schedule_id: z.string(),
    state: z.string(),
    total: z.number().int(),
    waiting_for_check: z.boolean(),
  })
  .passthrough();
export const WorkflowSummary = z
  .object({
    archived: z.boolean(),
    archived_at: z.union([z.string(), z.null()]).optional(),
    bulk_send: z.boolean(),
    description: z.string(),
    enabled: z.boolean(),
    failed_7d: z.number().int(),
    folder: z.string(),
    health: WorkflowHealth,
    id: z.string(),
    in_progress: z.number().int(),
    last_error: z.union([z.string(), z.null()]).optional(),
    last_run_at: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    overlaps: z.array(WorkflowOverlap),
    owner_name: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    record_type: RecordType,
    runs_7d: z.number().int(),
    send_once: z.union([z.null(), WorkflowSendOnce]).optional(),
    step_count: z.number().int(),
    tags: z.array(z.string()),
    total_runs: z.number().int(),
    trigger: WorkflowTrigger,
    trigger_text: z.string(),
    updated_at: z.string(),
    version: z.number().int(),
  })
  .passthrough();
export const WorkflowListResponse = z
  .object({
    can_manage: z.boolean(),
    condition_types: z.array(z.string()),
    folder_suggestions: z.array(z.string()),
    folders: z.array(WorkflowFolder),
    record_fields: z.array(WorkflowRecordFields),
    sms_available: z.boolean(),
    templates: z.array(WorkflowTemplate),
    workflows: z.array(WorkflowSummary),
  })
  .passthrough();
export const GoalOutcome = z.enum(["goal_reached", "exited"]);
export const WorkflowGoal = z
  .object({
    conditions: z.unknown().optional(),
    event: z.union([z.null(), WorkflowTrigger]).optional(),
    id: z.string().optional(),
    label: z.string().optional(),
    outcome: GoalOutcome,
  })
  .passthrough();
export const WorkflowSendLimit = z
  .object({
    daily: z.number().int(),
    warmup: z.array(z.number().int()).optional(),
  })
  .passthrough();
export const CreateWorkflowBody = z
  .object({
    bulk_send: z.boolean().optional(),
    conditions: z.unknown().optional(),
    description: z.union([z.string(), z.null()]).optional(),
    enabled: z.union([z.boolean(), z.null()]).optional(),
    folder: z.union([z.string(), z.null()]).optional(),
    goals: z.union([z.array(WorkflowGoal), z.null()]).optional(),
    name: z.string(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    send_limit: z.union([z.null(), WorkflowSendLimit]).optional(),
    steps: z.array(WorkflowStep),
    tags: z.union([z.array(z.string()), z.null()]).optional(),
    trigger: WorkflowTrigger,
  })
  .passthrough();
export const Workflow = z
  .object({
    archived_at: z.union([z.string(), z.null()]).optional(),
    bulk_send: z.boolean(),
    conditions: z.unknown(),
    created_at: z.string(),
    created_by: z.string(),
    description: z.string(),
    enabled: z.boolean(),
    folder: z.string(),
    goals: z.array(WorkflowGoal),
    id: z.string(),
    name: z.string(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    record_type: RecordType,
    send_limit: z.union([z.null(), WorkflowSendLimit]).optional(),
    steps: z.array(WorkflowStep),
    tags: z.array(z.string()),
    trigger: WorkflowTrigger,
    updated_at: z.string(),
    version: z.number().int(),
    webhook_secret: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WorkflowCheckBody = z
  .object({
    conditions: z.unknown().optional(),
    id: z.union([z.string(), z.null()]).optional(),
    steps: z.array(WorkflowStep),
    trigger: WorkflowTrigger,
  })
  .passthrough();
export const WorkflowMatch = z
  .object({
    enabled: z.boolean(),
    folder: z.string(),
    id: z.string(),
    name: z.string(),
  })
  .passthrough();
export const WorkflowCheckResponse = z
  .object({
    duplicates: z.array(WorkflowMatch),
    overlaps: z.array(WorkflowOverlap),
  })
  .passthrough();
export const WorkflowSendBudget = z
  .object({
    brand_id: z.union([z.string(), z.null()]).optional(),
    brand_limit: z.union([z.number(), z.null()]).optional(),
    brand_name: z.union([z.string(), z.null()]).optional(),
    brand_sent_today: z.number().int(),
    left_today: z.union([z.number(), z.null()]).optional(),
    sentence: z.string(),
    workflow_limit: z.union([z.number(), z.null()]).optional(),
    workflow_sent_today: z.number().int(),
  })
  .passthrough();
export const WorkflowRefType = z.enum([
  "campaign",
  "email_template",
  "email_brand",
  "email_campaign",
  "segment",
  "shared_segment",
  "rotation",
  "property",
  "band",
  "user",
  "pipeline",
  "stage",
  "link",
]);
export const UsedByWorkflow = z
  .object({
    archived: z.boolean(),
    enabled: z.boolean(),
    folder: z.string(),
    health: WorkflowHealthState,
    id: z.string(),
    name: z.string(),
  })
  .passthrough();
export const WorkflowUsedByResponse = z
  .object({
    active: z.number().int(),
    ref_id: z.string(),
    ref_type: WorkflowRefType,
    workflows: z.array(UsedByWorkflow),
  })
  .passthrough();
export const UpdateWorkflowBody = z
  .object({
    conditions: z.unknown(),
    description: z.union([z.string(), z.null()]),
    goals: z.union([z.array(WorkflowGoal), z.null()]),
    name: z.union([z.string(), z.null()]),
    send_limit: z.union([z.null(), WorkflowSendLimit]),
    steps: z.union([z.array(WorkflowStep), z.null()]),
    trigger: z.union([z.null(), WorkflowTrigger]),
  })
  .partial()
  .passthrough();
export const WorkflowStepReach = z
  .object({
    kind: StepKind,
    matched: z.union([z.number(), z.null()]).optional(),
    no: z.union([z.number(), z.null()]).optional(),
    passes: z.union([z.number(), z.null()]).optional(),
    reached: z.number().int(),
    step_id: z.string(),
    timed_out: z.union([z.number(), z.null()]).optional(),
    waiting_here: z.number().int(),
    yes: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const WorkflowAnalytics = z
  .object({
    active: z.number().int(),
    cancelled: z.number().int(),
    done: z.number().int(),
    enrolled: z.number().int(),
    enrolled_from_segments: z.number().int(),
    exited: z.number().int(),
    failed: z.number().int(),
    goal_conversion: z.union([z.number(), z.null()]).optional(),
    goal_reached: z.number().int(),
    steps: z.array(WorkflowStepReach),
    waiting: z.number().int(),
  })
  .passthrough();
export const WorkflowEmailLink = z
  .object({
    clicks: z.number().int(),
    link_name: z.string(),
    unique_clicks: z.number().int(),
    url: z.string(),
  })
  .passthrough();
export const WorkflowEmailStepStats = z
  .object({
    shared_with: z.array(z.string()),
    step_id: z.string(),
    template_id: z.string(),
    template_name: z.string(),
    totals: EmailStatTotals,
  })
  .passthrough();
export const WorkflowEmailStats = z
  .object({
    campaign_ids: z.array(z.string()),
    daily: z.array(EmailStatDay),
    days: z.number().int(),
    links: z.array(WorkflowEmailLink),
    steps: z.array(WorkflowEmailStepStats),
    totals: EmailStatTotals,
  })
  .passthrough();
export const EnrolFrequency = z.enum(["daily", "weekly", "once"]);
export const EnrolScheduleInput = z
  .object({
    at: z.union([z.string(), z.null()]).optional(),
    frequency: EnrolFrequency,
    reenrol: z.boolean().optional(),
    time: z.string().optional(),
    weekday: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const EnrolSegmentKind = z.enum(["private", "shared", "filter"]);
export const EnrolSegment = z
  .object({
    id: z.union([z.string(), z.null()]).optional(),
    kind: EnrolSegmentKind,
  })
  .passthrough();
export const EnrolBody = z
  .object({
    filter: LeadSearchBody,
    record_type: RecordType,
    schedule: z.union([z.null(), EnrolScheduleInput]).optional(),
    segment: EnrolSegment,
  })
  .passthrough();
export const WorkflowEnrolment = z
  .object({
    created_at: z.string(),
    created_by: z.string(),
    enrolled: z.number().int(),
    error: z.union([z.string(), z.null()]).optional(),
    finished_at: z.union([z.string(), z.null()]).optional(),
    id: z.number().int(),
    matched: z.number().int(),
    record_type: RecordType,
    schedule_id: z.union([z.string(), z.null()]).optional(),
    segment_kind: EnrolSegmentKind,
    segment_name: z.string(),
    skipped_active: z.number().int(),
    skipped_limit: z.number().int(),
    skipped_seen: z.number().int(),
    status: z.string(),
  })
  .passthrough();
export const EnrolPreview = z
  .object({
    already_checked: z.union([z.number(), z.null()]).optional(),
    count: z.number().int(),
    failed_check: z.union([z.number(), z.null()]).optional(),
    needs_checking: z.union([z.number(), z.null()]).optional(),
    not_stored: z.number().int(),
    on_never_email: z.union([z.number(), z.null()]).optional(),
    record_type: RecordType,
    segment_name: z.string(),
    send_budget: z.union([z.null(), WorkflowSendBudget]).optional(),
    send_warning: z.union([z.string(), z.null()]).optional(),
    sentence: z.string(),
    will_send: z.union([z.number(), z.null()]).optional(),
    with_consent: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const WorkflowEnrolSchedule = z
  .object({
    at: z.union([z.string(), z.null()]).optional(),
    created_by: z.string(),
    frequency: EnrolFrequency,
    id: z.string(),
    last_run_at: z.union([z.string(), z.null()]).optional(),
    next_run_at: z.union([z.string(), z.null()]).optional(),
    record_type: RecordType,
    reenrol: z.boolean(),
    segment_kind: EnrolSegmentKind,
    segment_name: z.string(),
    sentence: z.string(),
    status: z.string(),
    time: z.string(),
    verify_job_id: z.union([z.string(), z.null()]).optional(),
    verify_status: z.string(),
    waiting_for_check: z.boolean(),
    weekday: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const EnrolResponse = z
  .object({
    enrolment: z.union([z.null(), WorkflowEnrolment]).optional(),
    preview: EnrolPreview,
    schedule: z.union([z.null(), WorkflowEnrolSchedule]).optional(),
  })
  .passthrough();
export const EmailPreflightResponse = z
  .object({
    audience: z.number().int(),
    credits_available: z.union([z.number(), z.null()]).optional(),
    credits_error: z.string(),
    credits_needed: z.number().int(),
    elv_configured: z.boolean(),
    fresh: z.number().int(),
    fresh_blocked: z.number().int(),
    job: z.union([z.null(), EmailVerifyJobView]).optional(),
    needs_verification: z.number().int(),
    suppressed: z.number().int(),
    verify_status: z.string(),
  })
  .passthrough();
export const EmailVerifyBody = z.object({ mode: z.string() }).passthrough();
export const WorkflowEnrolmentsResponse = z
  .object({
    enrolments: z.array(WorkflowEnrolment),
    schedules: z.array(WorkflowEnrolSchedule),
  })
  .passthrough();
export const OrganiseWorkflowBody = z
  .object({
    folder: z.union([z.string(), z.null()]),
    owner_user_id: z.union([z.string(), z.null()]),
    tags: z.union([z.array(z.string()), z.null()]),
  })
  .partial()
  .passthrough();
export const WorkflowRunCounts = z
  .object({
    cancelled: z.number().int(),
    done: z.number().int(),
    exited: z.number().int(),
    failed: z.number().int(),
    goal_reached: z.number().int(),
    running: z.number().int(),
    waiting: z.number().int(),
  })
  .passthrough();
export const WorkflowRunListResponse = z
  .object({
    counts: WorkflowRunCounts,
    pagination: Pagination,
    runs: z.array(WorkflowRun),
  })
  .passthrough();
export const WorkflowRunStep = z
  .object({
    at: z.string(),
    detail: z.string(),
    kind: z.string(),
    status: z.string(),
    step_id: z.union([z.string(), z.null()]).optional(),
    step_index: z.number().int(),
  })
  .passthrough();
export const WorkflowRunDetail = z
  .object({
    log: z.array(WorkflowRunStep),
    run: WorkflowRun,
    steps: z.array(WorkflowStep),
  })
  .passthrough();
export const TestWorkflowBody = z
  .object({
    conditions: z.unknown().optional(),
    goals: z.union([z.array(WorkflowGoal), z.null()]).optional(),
    record_id: z.string(),
    record_type: RecordType,
    steps: z.union([z.array(WorkflowStep), z.null()]).optional(),
    trigger: z.union([z.null(), WorkflowTrigger]).optional(),
  })
  .passthrough();
export const WorkflowTestStep = z
  .object({
    acts: z.boolean(),
    depth: z.number().int(),
    kind: StepKind,
    path: z.union([z.string(), z.null()]).optional(),
    pending: z.boolean(),
    step_id: z.string(),
    would: z.string(),
  })
  .passthrough();
export const WorkflowTestResult = z
  .object({
    conditions_error: z.union([z.string(), z.null()]).optional(),
    conditions_met: z.union([z.boolean(), z.null()]).optional(),
    goal: z.union([z.string(), z.null()]).optional(),
    record_id: z.string(),
    record_name: z.string(),
    record_type: RecordType,
    steps: z.array(WorkflowTestStep),
  })
  .passthrough();

export const schemas = {
  owner_user_id,
  page,
  ActivityKind,
  ActivityObjectType,
  ActivityLink,
  ActivityStatus,
  Activity,
  Pagination,
  ActivityListResponse,
  ProblemDetails,
  ActivityLinkInput,
  CreateActivityBody,
  UpdateActivityBody,
  Alert,
  AlertListResponse,
  CreateAlertBody,
  AlertWriteResponse,
  UpdateAlertBody,
  Caps,
  ActiveHours,
  AssignmentRep,
  AssignmentGroup,
  AssignmentGroupList,
  AssignmentRepInput,
  CreateAssignmentGroupBody,
  UpdateAssignmentGroupBody,
  SetAssignmentRepsBody,
  AssignmentJob,
  AssignmentJobList,
  FieldFilter,
  LeadSearchBody,
  AssignPeopleBody,
  AssignmentJobItem,
  AssignmentJobDetail,
  AssistantStatus,
  AssistantMessage,
  AssistantChatBody,
  QueryStats,
  AssistantSource,
  AssistantChatResponse,
  AuditLogEntry,
  AuditLogListResponse,
  FacetValue,
  AuditFacetsResponse,
  StreamDoes,
  CampaignSummary,
  MoneyPresence,
  CampaignListResponse,
  CreateCampaignBody,
  CreateCampaignResponse,
  ArrivalChecks,
  CampaignField,
  ActiveDaysResolution,
  PhoneCheckSettings,
  PriceResolution,
  GroupDestination,
  RouteGroup,
  CampaignSettings,
  CampaignDetailResponse,
  UpdateCampaignBody,
  UpdateCampaignResponse,
  ResetApiKeyResponse,
  UpdateCampaignFieldsBody,
  CreateRouteGroupBody,
  CreateRouteGroupResponse,
  UpdateRouteGroupBody,
  UpdateRouteGroupResponse,
  LinkDestinationBody,
  UpdateGroupDestinationResponse,
  UpdateGroupDestinationBody,
  UnlinkDestinationResponse,
  RoutingOutcome,
  RoutingReason,
  GroupOutcomes,
  RoutingOutcomesResponse,
  CompanyRoleLink,
  CompanyRoleKey,
  CompanyRole,
  CompanySummary,
  CompanyListResponse,
  CreateCompanyBody,
  CompanyDealTotals,
  DealStatus,
  DealSummary,
  CompanyDetail,
  BulkOwnerBody,
  BulkOwnerSkip,
  BulkOwnerResult,
  UpdateCompanyBody,
  MergeCompanyBody,
  CompanyMergeResult,
  RoleCampaign,
  RoleRouteLink,
  RoleDestination,
  RoleFigures,
  CompanyRoleUse,
  BuyerRoleActivity,
  SupplierCampaignCost,
  SupplierRoleActivity,
  CompanyRoleActivity,
  AddCompanyRoleBody,
  NamedCount,
  HourlyPoint,
  TimeSeriesPoint,
  MoneyVisibility,
  RevenuePoint,
  TopCampaign,
  DashboardStatsResponse,
  DealListResponse,
  DealPerson,
  CreateDealBody,
  DealStageChange,
  StageKind,
  DealDetail,
  OwnerTotals,
  StageTotals,
  DealsSummaryResponse,
  UpdateDealBody,
  MoveDealBody,
  Destination,
  DestinationListResponse,
  AcceptRule,
  Acceptance,
  ConfigPair,
  DestinationConfig,
  UpsertDestinationBody,
  UpsertDestinationResponse,
  AcceptanceCheckBody,
  RuleCheck,
  Verdict,
  AcceptanceCheckResponse,
  TestDestinationBody,
  TestDestinationResponse,
  LegacyResponseSettings,
  DestinationDetailResponse,
  DestinationBuyerChangeLink,
  DestinationBuyerChangeResponse,
  RegisterDeviceTokenBody,
  EmailBrand,
  EmailBrandListResponse,
  EmailBrandBody,
  EmailTemplateWriteResponse,
  EmailAudience,
  EmailCampaign,
  EmailCampaignListResponse,
  ElvCreditsView,
  EmailSuppressionCounts,
  EmailRateThresholds,
  EmailVerificationCount,
  EmailHygieneResponse,
  EmailStatTotals,
  EmailCampaignStats,
  EmailStatDay,
  EmailHealth,
  EmailStatsResponse,
  EmailSuppression,
  EmailSuppressionListResponse,
  EmailAddressBody,
  EmailSuppressionCheckResponse,
  EmailTemplateSummary,
  EmailTemplateListResponse,
  CreateEmailTemplateBody,
  EmailTemplate,
  UpdateEmailTemplateBody,
  EmailAiEditBody,
  EmailAiEditResponse,
  EmailTemplateLink,
  EmailTemplateLinksResponse,
  SendTestEmailBody,
  SendTestEmailResponse,
  EmailVerifyJobView,
  Entity,
  EntityListResponse,
  EntityBody,
  PersonBrief,
  IdentitySuggestion,
  SuggestionListResponse,
  SuggestionDecisionBody,
  SuggestionDecisionResponse,
  ImportSampleInfo,
  ImportReason,
  ImportLive,
  ImportJob,
  ImportListResponse,
  StartImportRequest,
  StartImportResponse,
  ImportPreflightBody,
  PreflightPrevious,
  PreflightRoute,
  ImportPreflightResponse,
  ImportTestSendBody,
  TestSendResult,
  ImportTestSendResponse,
  ImportProgress,
  ImportActionResponse,
  LeadField,
  LeadFieldsResponse,
  LeadFieldPreviewBody,
  LeadFieldPreviewReason,
  LeadFieldPreviewResponse,
  LeadFieldValue,
  LeadFieldValuesResponse,
  ScoreBandRef,
  LeadSummary,
  LeadListResponse,
  LeadCustomKeysResponse,
  LeadFacetsResponse,
  InsightsOverall,
  InsightsRow,
  InsightsResponse,
  RedistributeBody,
  RedistributeResponse,
  LeadSearchInterpretStatus,
  LeadSearchInterpretBody,
  LeadSearchInterpretResponse,
  SegmentCountInput,
  SegmentCountsBody,
  SegmentCount,
  SegmentCountsResponse,
  DistributionAttempt,
  DuplicateInfo,
  PhoneCheck,
  DistributionSummary,
  PropertyType,
  SubmissionProperty,
  ScoreRuleError,
  ScoreContribution,
  LeadScoreDetail,
  LeadDetailResponse,
  ReturnLeadBody,
  LeadReturn,
  ReturnLeadResponse,
  ReturnableSale,
  LeadReturns,
  FilterTab,
  FilterTabsResponse,
  Appearance,
  UserPreferences,
  EnumValue,
  AlertEventType,
  RoleDefaults,
  FilterOption,
  FilterType,
  EnumsResponse,
  NotificationItem,
  NotificationListResponse,
  AffectedResponse,
  PersonStream,
  PersonSummary,
  PeopleSource,
  PeopleListResponse,
  PeopleCountStream,
  PeopleCountPoint,
  PeopleCountsResponse,
  PersonLinkView,
  PersonLinkResponse,
  PeopleSearchBody,
  PersonBase,
  PersonScore,
  PersonSubmission,
  PersonDetail,
  UpdatePersonBody,
  PersonPropertiesView,
  MergePeopleBody,
  SetOwnerBody,
  OwnerView,
  PipelineStage,
  Pipeline,
  PipelineListResponse,
  CreateStageBody,
  CreatePipelineBody,
  UpdatePipelineBody,
  ReorderStagesBody,
  UpdateStageBody,
  include_archived,
  PropertyObject,
  PropertyOption,
  PropertyDef,
  PropertyListResponse,
  CreatePropertyBody,
  PropertyPositionsBody,
  SeedPropertiesBody,
  SeedSkipped,
  SeedPropertiesResponse,
  UpdatePropertyBody,
  RecordType,
  WorkflowRunStatus,
  TriggerKind,
  WorkflowRun,
  RecordWorkflowRunsResponse,
  BuyerPerformanceRow,
  StatusCount,
  CampaignPerformanceRow,
  ReportMetrics,
  ReportsResponse,
  EntityStat,
  EntityStatsResponse,
  ExploreRequest,
  ExploreRow,
  ExploreTotals,
  ExploreResponse,
  ReturnsReportRow,
  ReturnsReport,
  ReportView,
  ReportViewListResponse,
  CreateReportView,
  ReturnCounts,
  ReturnsList,
  CreateReturnsBody,
  ReturnFailure,
  ReturnsResult,
  ReturnDecision,
  DecideReturnsBody,
  RequestReturnBody,
  RouteOverview,
  UnlinkedDestination,
  RoutesOverviewResponse,
  DraftScoringRule,
  ScorePreviewBody,
  ScoreBandCount,
  ScorePreviewExample,
  ScoreBucket,
  ScoreRuleHits,
  ScorePreviewResponse,
  ScoreFact,
  ScoreObject,
  ScoringRule,
  ScoringRuleListResponse,
  CreateScoringRuleBody,
  ReorderScoringRulesBody,
  UpdateScoringRuleBody,
  ActivateScoringRuleBody,
  SegmentPerson,
  SegmentPeople,
  SegmentVisibility,
  SharedSegment,
  SharedSegmentList,
  CreateSharedSegmentBody,
  UpdateSharedSegmentBody,
  SegmentMadePrivate,
  AiSettingsView,
  AiSettingsBody,
  ApnsSettingsView,
  ApnsSettings,
  BillingSettings,
  CrmAccessSettings,
  BrandSunset,
  SunsetSettings,
  ElvSettingsView,
  ElvSettingsBody,
  ElvTestBody,
  ElvTestResponse,
  FeatureSettings,
  HlrSettingsView,
  HlrSettings,
  PeopleLayerStatus,
  IdentitySettings,
  IdentitySettingsBody,
  ReturnReason,
  ReturnsSettings,
  ScoreBand,
  ScoreDecay,
  ScoringSettings,
  SesSettingsView,
  SesSettingsBody,
  SesHookResponse,
  VocabularyPreset,
  VocabularySettingsView,
  VocabularySettings,
  SheetCampaign,
  Sheet,
  SheetListResponse,
  CreateSheetBody,
  UpdateSheetBody,
  ReorderColumnsBody,
  AddColumnBody,
  DropColumnBody,
  RenameColumnBody,
  CommitSheetBody,
  ComputedColumnBody,
  SheetCountCell,
  SheetCountBody,
  SheetCountResult,
  SheetCounts,
  DedupeBody,
  SheetFilterSpec,
  DeleteRowsBody,
  SheetDuplicate,
  SheetDuplicates,
  SheetEdit,
  SheetEditsBody,
  SheetEditSummary,
  FormulaColumnBody,
  FormulaCheck,
  SheetHistoryCheck,
  SheetHistoryImport,
  SheetVersion,
  SheetHistory,
  SheetImportBody,
  SheetJobStarted,
  MatchLeadsBody,
  MatchLeadsResponse,
  SheetPage,
  SheetColumnStats,
  SheetStats,
  SheetSummaryValue,
  SheetSummary,
  SuppressBody,
  SheetTransform,
  SheetTransformList,
  SheetTransformBody,
  SheetVerifyBody,
  StatementKind,
  Totals,
  StatementSummary,
  StatementList,
  LineKind,
  SummaryLine,
  PartyDetails,
  Statement,
  FinaliseBody,
  MarkPaidBody,
  TaskCounts,
  TaskListResponse,
  TemplateSummary,
  TemplateListResponse,
  ApplyTemplateBody,
  ApplyTemplateResponse,
  TemplatePreview,
  TimelineItemKind,
  TimelineLinkType,
  TimelineLink,
  TimelineItem,
  TimelineSummary,
  TimelineResponse,
  VerifyJob,
  VerifyJobListResponse,
  WorkflowFolder,
  WorkflowFoldersResponse,
  WorkflowFolderBody,
  WorkflowField,
  WorkflowRecordFields,
  StepKind,
  WorkflowStep,
  EmailEventKind,
  WorkflowTrigger,
  WorkflowTemplate,
  WorkflowHealthState,
  WorkflowHealth,
  WorkflowOverlap,
  WorkflowSendOnce,
  WorkflowSummary,
  WorkflowListResponse,
  GoalOutcome,
  WorkflowGoal,
  WorkflowSendLimit,
  CreateWorkflowBody,
  Workflow,
  WorkflowCheckBody,
  WorkflowMatch,
  WorkflowCheckResponse,
  WorkflowSendBudget,
  WorkflowRefType,
  UsedByWorkflow,
  WorkflowUsedByResponse,
  UpdateWorkflowBody,
  WorkflowStepReach,
  WorkflowAnalytics,
  WorkflowEmailLink,
  WorkflowEmailStepStats,
  WorkflowEmailStats,
  EnrolFrequency,
  EnrolScheduleInput,
  EnrolSegmentKind,
  EnrolSegment,
  EnrolBody,
  WorkflowEnrolment,
  EnrolPreview,
  WorkflowEnrolSchedule,
  EnrolResponse,
  EmailPreflightResponse,
  EmailVerifyBody,
  WorkflowEnrolmentsResponse,
  OrganiseWorkflowBody,
  WorkflowRunCounts,
  WorkflowRunListResponse,
  WorkflowRunStep,
  WorkflowRunDetail,
  TestWorkflowBody,
  WorkflowTestStep,
  WorkflowTestResult,
};
